// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.full-width {
  width: 100% !important;
  max-width: 100% !important;
}

.sticky-header {
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
}

.app-header {
  padding: 0 18px;
}
@media (max-width: 767px) {
  .app-header {
    padding: 0 10px;
  }
  .app-header > .row {
    margin: 0;
  }
  .app-header > .row .header-right-col {
    padding-right: 0;
  }
}

.app-footer {
  padding: 12px 18px;
}
@media (max-width: 767px) {
  .app-footer {
    padding: 10px;
    margin-top: 18px;
  }
}

.sticky-footer {
  position: fixed;
  z-index: 10;
  bottom: 0;
  right: 0;
  left: 0;
}

.for-stickies {
  padding: 120px 0 100px;
}

.sticky-header > *, .sticky-footer > *, .for-stickies > * {
  margin: 0 30px;
}

.modal-header-x {
  cursor: pointer;
}

.sided-modal-body {
  margin: 0;
  padding: 30px;
}

.padding-s {
  padding: 20px 25px;
}

.loader-top {
  bottom: 0px;
  height: auto;
}

.sided-modal-title {
  color: #000;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 15px;
}

.sided-modal-footer {
  margin-top: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sided-modal-checkers {
  color: #000;
  font-size: 14px;
  background: #F6F6F7;
  margin: 0 -25px 20px;
  border-top: 1px solid #E0E0E0;
}
@media (max-width: 767px) {
  .sided-modal-checkers {
    margin: 0 -15px 10px;
  }
}
.sided-modal-checkers > div {
  border: 0 none;
  padding: 0 25px;
  margin-bottom: 7px;
}
.sided-modal-checkers > div:first-child {
  background: #fff;
  margin-bottom: 0;
  padding: 12px 25px;
}
.sided-modal-checkers > div:first-child + div {
  padding-top: 20px;
}
.sided-modal-checkers > div:last-child {
  margin-bottom: 0;
  padding-bottom: 20px;
}
.sided-modal-checkers label {
  cursor: pointer;
}

.output-box {
  margin-bottom: 20px;
}
.output-box h3 {
  margin: 0;
  display: flex;
  font-size: 1.2em;
  align-items: center;
}
.output-box h3 svg {
  margin-right: 5px;
}

.network-box {
  display: flex;
  padding: 18px 12px;
  border-radius: 7px;
  align-items: center;
  margin-bottom: 20px;
  background: #F7F7F7;
}
.network-box-logo {
  margin-right: 10px;
  border-radius: 50%;
  overflow: hidden;
}
.network-box-logo img {
  width: 45px;
  height: 45px;
}
.network-box-text {
  line-height: 1.1;
}
.network-box-text small {
  color: #989898;
}

.sided-modal-search {
  margin-bottom: 20px;
}
.sided-modal-search input {
  width: 360px;
  max-width: 100%;
}

.network-list {
  overflow: auto;
  max-height: 370px;
  margin-bottom: 40px;
}
.network-list-row {
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #F2F2F2;
}
.network-list-row label {
  font-size: inherit;
}
.network-list-item {
  display: flex;
  align-items: center;
}
.network-list-name {
  width: 40%;
}
.network-list-id {
  line-height: 1.1;
  margin-left: 8px;
}
.network-list-id small {
  opacity: 0.7;
  font-size: 0.8em;
}
.network-list-count {
  width: 90px;
  text-align: center;
}
.network-list-buttons {
  flex-grow: 1;
  text-align: right;
}
.network-list-buttons > .btn {
  width: auto;
  font-size: 14px;
  margin-right: 5px;
  padding: 7px 15px;
}
.network-list-buttons > select {
  width: 120px;
  height: 37px;
  padding: 0 8px;
  font-size: 14px;
  border-radius: 6px;
  vertical-align: middle;
}
.network-list-logo img {
  width: 26px;
  height: 26px;
  display: block;
  object-fit: cover;
  border-radius: 50%;
  border: 1px solid #D9D9D9;
}

.text-button {
  cursor: pointer;
  font-size: 12px;
  color: #2F80ED;
}

.icon-right svg {
  margin: 0 0 0 5px;
}

.underlined {
  text-decoration: underline;
}

.inherit-font {
  font-size: inherit;
}

> svg:first-child {
  margin-right: 5px;
}

input.sided-checkbox {
  padding: 0;
  margin: 0 12px 0 0;
  vertical-align: -1px;
}

.standard-label {
  font-weight: normal !important;
}
.standard-label .text-button {
  font-size: 1em;
}

.syndication-init {
  display: flex;
  margin-top: 10px;
  justify-content: space-between;
}
.syndication-init label {
  position: relative;
  margin-bottom: -3px !important;
  line-height: 16px !important;
}
.syndication-init label input {
  left: 0;
  top: 3px;
  position: absolute;
}
.syndication-init label strong {
  font-weight: 700 !important;
}
.syndication-init .btn {
  width: auto;
  font-size: 14px;
  padding: 7px 15px;
}

.default-formfield {
  margin-bottom: 20px;
}
.default-formfield label {
  display: block;
  color: #4F4F4F;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 5px;
}
.default-formfield textarea, .default-formfield select {
  width: 100%;
  height: 40px;
  padding: 5px 10px;
  border-radius: 5px;
  border: 1px solid #D9D9D9;
}
.default-formfield textarea {
  height: 80px;
}

.pre-auth-box {
  color: #333;
  font-size: 14px;
  text-align: center;
  margin-bottom: 25px;
}

.auth-box {
  width: 773px;
  display: flex;
  margin: 0 auto;
  max-width: 100%;
  min-height: 500px;
  padding: 30px 45px;
  border-radius: 5px;
  align-items: center;
  background: #F9F9F9;
}
.auth-box-inner {
  width: 100%;
}
.auth-box-header {
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.auth-box-step {
  color: #333;
  font-size: 14px;
  font-weight: 700;
}
.auth-box-logo {
  text-align: center;
  margin-bottom: 18px;
}
.auth-box-logo img {
  width: 50px;
  height: 50px;
}
.auth-box-title {
  color: #333;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
  margin-bottom: 30px;
}
.auth-box-subtitle {
  font-size: 14px;
  max-width: 580px;
  text-align: center;
  margin: 0 auto 30px;
}
.auth-box form {
  width: 344px;
  margin: 0 auto;
  max-width: 100%;
}
.auth-box form fieldset label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 5px;
}
.auth-box form fieldset input[type=text], .auth-box form fieldset input[type=email], .auth-box form fieldset input[type=tel], .auth-box form fieldset input[type=password] {
  font-size: 12px;
  margin-bottom: 10px;
}
.auth-box form fieldset input[type=text].mb2x, .auth-box form fieldset input[type=email].mb2x, .auth-box form fieldset input[type=tel].mb2x, .auth-box form fieldset input[type=password].mb2x {
  margin-bottom: 20px;
}
.auth-box form fieldset input[type=text] + .input-group-prepend .input-group-text, .auth-box form fieldset input[type=email] + .input-group-prepend .input-group-text, .auth-box form fieldset input[type=tel] + .input-group-prepend .input-group-text, .auth-box form fieldset input[type=password] + .input-group-prepend .input-group-text {
  color: #828282;
  padding: 0 10px;
  font-size: 12px;
  line-height: 34px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.auth-box form fieldset input[type=checkbox] {
  margin: 0 5px 0 0;
  vertical-align: -2px;
}
.auth-box form fieldset input + .validation-error {
  margin: -10px 0 10px;
}
.auth-box form fieldset .textarea2 {
  width: 100%;
}
.auth-box form fieldset .input-info {
  font-size: 12px;
  line-height: 1.3;
  margin: -7px 0 10px;
}
.auth-box form fieldset .input-info.after-mb2x {
  margin: -17px 0 20px;
}
.auth-box form fieldset .input-info.mt0 {
  margin-top: 0;
}
.auth-box form fieldset .input-info.mb2x {
  margin-bottom: 20px;
}
.auth-box form fieldset .input-info + .validation-error {
  margin-top: -10px;
}
.auth-box form fieldset .input-button {
  text-align: right;
  margin-bottom: 20px;
}
.auth-box form fieldset.code-fields {
  display: flex;
  justify-content: space-between;
}
.auth-box form fieldset.code-fields input {
  margin: 0;
  width: 48px;
  height: 58px;
  font-size: 18px;
  max-width: 16.6%;
  font-weight: 700;
  text-align: center;
  display: inline-block;
}
.auth-box form fieldset.code-fields + .end-option {
  margin-bottom: 100px;
}
.auth-box form fieldset .two-fields {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.auth-box form fieldset .two-fields > div {
  width: 48%;
}
.auth-box form fieldset .multi-field {
  position: relative;
  margin-bottom: 10px;
}
.auth-box form fieldset .multi-field.mb2x {
  margin-bottom: 20px;
}
.auth-box form fieldset .multi-field input {
  margin: 0;
}
.auth-box form fieldset .multi-field span {
  top: 5px;
  right: 10px;
  cursor: pointer;
  position: absolute;
}
.auth-box form .validation-error {
  white-space: pre-line;
}
.auth-box form .multi-check {
  font-size: 11px;
  margin-bottom: 10px;
}
.auth-box form .multi-check label {
  font-size: 1em;
  margin-left: 10px;
  display: inline;
}
.auth-box form .text-line {
  display: block;
  color: #9B9B9B;
  font-size: 10px;
  margin-top: 25px;
  text-align: center;
  white-space: nowrap;
}
.auth-box form .text-line a, .auth-box form .text-line .text-button {
  margin: 0 5px;
  color: #9B9B9B;
  display: inline;
  text-decoration: underline;
}
.auth-box form .text-line.mt0 {
  margin-top: 0;
}
.auth-box .button-holder {
  margin-top: 25px;
  text-align: center;
}
.auth-box .button-holder button, .auth-box .button-holder .button {
  color: #fff;
  width: 244px;
  border: 0 none;
  font-size: 12px;
  padding: 10px 0;
  border-radius: 5px;
  text-align: center;
  background: #2F80ED;
}
.auth-box .button-holder button:hover, .auth-box .button-holder .button:hover {
  color: #fff;
  background: #2F80ED;
}
.auth-box .button-holder button.bordered, .auth-box .button-holder .button.bordered {
  padding: 9px 0;
  color: #2F80ED;
  background: transparent;
  border: 1px solid #2F80ED;
}
.auth-box .button-holder button.grayed, .auth-box .button-holder .button.grayed {
  color: #BDBDBD;
  background: #F2F2F2;
}
.auth-box .button-holder button.green, .auth-box .button-holder .button.green {
  background: #27AE60;
}
.auth-box .button-holder.mt0 {
  margin-top: 0;
}
.auth-box .button-holder.mtl {
  margin-top: 35px;
}
.auth-box .button-holder.has-two {
  text-align: right;
}
.auth-box .button-holder.has-two button {
  width: 80px;
  margin-left: 10px;
}
.auth-box .button-holder.has-halfs {
  display: flex;
  justify-content: space-between;
}
.auth-box .button-holder.has-halfs button, .auth-box .button-holder.has-halfs .button {
  width: 48%;
}
.auth-box .logo-uploader {
  width: 64px;
  padding: 5px;
  cursor: pointer;
  background: #fff;
  border-radius: 50%;
  box-sizing: content-box;
  border: 1px dashed #828282;
}
.auth-box .logo-uploader-inner {
  height: 64px;
  display: flex;
  overflow: hidden;
  position: relative;
  border-radius: 50%;
  background: #EBEBEB;
  align-items: center;
  justify-content: center;
}
.auth-box .logo-uploader-inner input {
  top: 0;
  left: 0;
  z-index: 5;
  opacity: 0;
  position: absolute;
  transform: scale(10);
}
.auth-box .logo-uploader-inner img {
  top: 0;
  left: 0;
  z-index: 4;
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
}
.auth-box .logo-uploader-note {
  width: 76px;
  color: #BDBDBD;
  font-size: 11px;
  text-align: center;
}
.auth-box .end-option {
  font-size: 12px;
  margin-top: 25px;
  text-align: center;
}

.alt-option {
  display: flex;
  margin: 5px 0 25px;
  justify-content: space-between;
}
.alt-option.mw360 {
  max-width: 360px;
  margin-left: auto;
  margin-right: auto;
}

.status-label {
  color: #888;
  margin: 0 5px 0 0;
}

.modal-tabs {
  display: flex;
  margin-bottom: 30px;
  border-bottom: 1px solid #E4E4E4;
}
.modal-tabs .modal-tab {
  color: #5A9AF0;
  cursor: pointer;
  padding: 15px 40px;
  border: 1px solid #E4E4E4;
  border-bottom: 0 none;
  background-image: linear-gradient(#fff, #F6F6F6);
}
.modal-tabs .modal-tab:first-child {
  border-top-left-radius: 5px;
}
.modal-tabs .modal-tab:last-child {
  border-top-right-radius: 5px;
}
.modal-tabs .modal-tab.active {
  color: #787878;
  background: #fff;
  position: relative;
}
.modal-tabs .modal-tab.active:after {
  left: 0;
  right: 0;
  top: 100%;
  height: 1px;
  content: "";
  background: #fff;
  position: absolute;
}

.page-title {
  color: #000;
  font-size: 22px;
  line-height: 1.36;
  margin-bottom: 30px;
}
.page-title.uppercase {
  text-transform: uppercase;
}

.section-title {
  font-weight: 600;
  color: #000 !important;
  font-size: 14px !important;
  margin: 0 0 20px !important;
  line-height: 1.36 !important;
}

.general-stats {
  color: #000;
  display: flex;
  padding: 18px 0;
  font-size: 13px;
  margin: 0 0 30px;
  font-weight: 600;
  text-align: center;
  border-radius: 4px;
  background: #FAFAFA;
}
.general-stats > div {
  width: 25%;
  border-right: 1px solid #E0E0E0;
}
.general-stats > div:last-child {
  border-right: 0;
}
.general-stats-value {
  color: #2F80ED;
  font-size: 28px;
}

.table-filters {
  display: flex;
  margin-bottom: 18px;
  justify-content: space-between;
}
.table-filters.mb-xl {
  margin-bottom: 45px;
}
.table-filters-start {
  display: flex;
  align-items: center;
}

.table-checker {
  margin-right: 15px;
}
.table-checker input {
  margin: 0;
  padding: 0;
}

.table-sorter label {
  font-size: 14px;
  margin-right: 10px;
  vertical-align: middle;
}
.table-sorter select {
  height: 28px;
  padding: 0 5px;
  font-size: 11px;
  font-weight: 600;
  color: #2F80ED;
  border-radius: 3px;
  vertical-align: middle;
  border: 1px solid #2F80ED;
}

.table-search {
  position: relative;
}
.table-search svg {
  top: 50%;
  left: 13px;
  margin-top: -9px;
  position: absolute;
}
.table-search input {
  width: 430px;
  height: 40px;
  font-size: 12px;
  background: #fff;
  border-radius: 4px;
  padding: 0 0 0 40px;
  box-sizing: border-box;
}

.table-pagination {
  display: flex;
  color: #4F4F4F;
  font-size: 12px;
  font-weight: 600;
  align-items: center;
}
.table-pagination > span + span {
  margin-left: 10px;
}
.table-pagination-nav {
  width: 34px;
  height: 34px;
  display: flex;
  cursor: pointer;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  background: #F6F6F6;
}
.table-pagination-prev {
  transform: scaleX(-1);
}

.table-holder {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border: 1px solid #E0E0E0;
  border-bottom: 0 none;
}

.table-selectors {
  display: flex;
  font-size: 11px;
  padding: 6px 10px;
  border-bottom: 1px solid #E0E0E0;
}

.table-control {
  margin-right: 6px;
  position: relative;
}
.table-control-value {
  height: 40px;
  display: flex;
  cursor: pointer;
  padding: 0 16px;
  font-weight: 600;
  border-radius: 4px;
  align-items: center;
  background: #F2F2F2;
}
.table-control-value .selected-value {
  height: 28px;
  display: flex;
  color: #4F4F4F;
  padding: 0 10px;
  margin-left: 10px;
  border-radius: 4px;
  align-items: center;
  background: #F6F6F6;
}
.table-control-value .selected-value svg {
  margin-left: 8px;
}
.table-control-value .quick-link {
  color: #fff;
  margin-left: 20px;
  text-decoration: underline;
}
.table-control-arrow {
  margin-left: 10px;
}
.table-control.growing {
  flex-grow: 1;
}
.table-control.active .table-control-value {
  color: #fff;
  background: #2F80ED;
}
.table-control.active .table-control-value svg path {
  fill: #fff;
}
.table-control:last-child {
  margin-right: 0;
}
.table-control .table-control-dropdown {
  left: 0;
  right: auto;
  top: 100%;
  z-index: 10;
  width: 360px;
  font-size: 13px;
  background: #fff;
  padding: 20px 15px;
  position: absolute;
  box-sizing: border-box;
  border: 1px solid #E0E0E0;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  z-index: 9;
}
.table-control .table-control-dropdown ul {
  padding: 0;
  overflow: auto;
  margin: 12px 0 0;
  max-height: 180px;
  list-style-type: none;
}
.table-control .table-control-dropdown ul li {
  cursor: pointer;
  padding: 5px 12px;
}
.table-control .table-control-dropdown ul li:hover {
  border-radius: 4px;
  background: #E0E0E0;
}
.table-control .icon-export {
  width: 12px;
  height: 17px;
  margin-right: 10px;
}

.table-body {
  overflow: auto;
  min-width: 100%;
}
.table-body.top-border {
  border-top: 1px solid #E0E0E0;
}

.table-row {
  font-size: 14px;
  justify-content: space-between;
}
.table-row.font-size-x {
  font-size: 12px;
}
.table-row .table-row-checkbox {
  margin: 0;
}
.table-row + .blue-button {
  margin-left: 10px;
}

.table-cell {
  box-sizing: border-box;
  padding: 15px 15px 15px 0;
  border-bottom: 1px solid #E0E0E0;
}
.table-cell-labelled {
  font-size: 11px;
  line-height: 1.3;
}
.table-cell-labelled strong {
  font-size: 14px;
}
.table-cell-text {
  max-width: 200px;
  display: inline-block;
  word-wrap: break-word;
}
.table-cell.x-center {
  justify-content: center;
}
.table-cell.border-right {
  border-right: 1px solid #E0E0E0;
}
.table-cell.border-right + .table-cell {
  padding-left: 10px;
}
.table-cell.padding-r-0 {
  padding-right: 0;
}
.table-cell input {
  margin: 0;
  vertical-align: middle;
}
.table-cell .inline-buttons {
  width: 100%;
  display: flex;
  justify-content: right;
}

.select-box {
  height: 40px;
  padding: 0 10px;
  font-size: 12px;
  border-radius: 4px;
  border: 1px solid #E0E0E0;
}

.input-box {
  height: 40px;
  padding: 0 10px;
  font-size: 12px;
  border-radius: 4px;
  border: 1px solid #E0E0E0;
}

.blue-button {
  color: #fff;
  height: 38px;
  display: flex;
  cursor: pointer;
  padding: 0 15px;
  font-size: 12px;
  border-radius: 4px;
  align-items: center;
  background: #2F80ED;
  border: 1px solid #2F80ED;
}
.blue-button:hover {
  color: #fff;
}
.blue-button[disabled] {
  opacity: 0.5;
}
.blue-button.gray {
  color: #959595;
  background: #F6F6F6;
  border: 1px solid #F6F6F6;
}
.blue-button.size-l {
  height: 50px;
  padding: 0 30px;
  font-size: 14px;
}
.blue-button.bordered {
  background: #fff;
  color: #2F80ED;
}
.blue-button.inline {
  line-height: 38px;
  display: inline-block;
}
.blue-button.inline.bordered {
  line-height: 36px;
}
.blue-button svg {
  margin-right: 10px;
  vertical-align: -5px;
}

.segment-form {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border: 1px solid #E0E0E0;
}
.segment-form.after-tabs {
  border-top-left-radius: 0;
}
.segment-form header {
  z-index: 5;
  padding: 6px;
  display: flex;
  background: transparent;
  justify-content: space-between;
  border-bottom: 1px solid #E0E0E0;
}
.segment-form header > * {
  margin-left: 7px;
}
.segment-form header > *:first-child {
  flex-grow: 1;
  margin-left: 0;
}
.segment-form-body {
  padding: 25px 40px 100px;
}
.segment-form-body.padding-s {
  padding: 25px 45px 50px;
}
.segment-form-field {
  margin-bottom: 20px;
}
.segment-form-field.mb-l {
  margin-bottom: 40px;
}
.segment-form-field .inner-dropdown {
  position: relative;
  background: #FCFCFC;
}
.segment-form-field .inner-dropdown input[type=text] {
  cursor: pointer;
  position: relative;
  background: transparent;
}
.segment-form-field .inner-dropdown .dropdown-arrow {
  top: 50%;
  right: 16px;
  cursor: pointer;
  position: absolute;
  transform: translateY(-50%);
}
.segment-form-field .inner-dropdown .auto-complete {
  left: 0;
  right: 0;
  top: 100%;
  position: absolute;
}
.segment-form-field label {
  display: block;
  font-size: 14px;
  margin-bottom: 5px;
}
.segment-form-field label.type-2 {
  color: #4f4f4f;
  font-weight: 700;
  margin-bottom: 12px;
}
.segment-form-field label .info-note {
  color: #828282;
  font-size: 12px;
  margin-left: 20px;
  font-weight: normal;
}
.segment-form-field input {
  width: 300px;
  font-size: 12px;
  padding: 10px 15px;
}
.segment-form-picker {
  overflow: hidden;
  position: relative;
  vertical-align: top;
  display: inline-block;
}
.segment-form-image .blue-button {
  vertical-align: top;
  display: inline-block;
}
.segment-form-image input {
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  opacity: 0;
  display: block;
  cursor: pointer;
  position: absolute;
  transform: scale(3);
}
.segment-form-image img {
  max-width: 300px;
}
.segment-form-info {
  font-size: 14px;
  padding: 20px 0;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #E0E0E0;
  border-bottom: 1px solid #E0E0E0;
}
.segment-form-info .select-box {
  margin: 0 10px;
}
.segment-form-info label {
  font-size: inherit;
}
.segment-form-condition {
  margin-bottom: 15px;
  padding-bottom: 20px;
  border-bottom: 1px solid #E0E0E0;
}
.segment-form-condition .select-box, .segment-form-condition .input-box {
  margin-right: 6px;
}
.segment-form-match {
  font-weight: 700;
  margin-bottom: 15px;
}
.segment-form-plus {
  margin: 24px 0;
}
.segment-form-buttons {
  display: flex;
  align-items: center;
}
.segment-form-buttons > * {
  font-weight: 700;
  margin-right: 8px;
}
.segment-form-buttons.align-right {
  justify-content: flex-end;
}
.segment-form-buttons.align-right > * {
  margin: 0 0 0 40px;
}
.segment-form .blue-button .icon-export {
  width: 12px;
  height: 17px;
}
.segment-form .blue-button .icon-export path {
  fill: #fff;
}

.modal-cta {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  display: flex;
  position: fixed;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
}
.modal-cta-inner {
  background: #fff;
  text-align: center;
  border-radius: 10px;
  padding: 20px 20px 15px;
}
.modal-cta-buttons {
  display: flex;
  justify-content: center;
}
.modal-cta-buttons .blue-button {
  margin: 5px;
}

.quiz-side {
  position: relative;
  padding-left: 20px;
}
.quiz-side input[type=checkbox] {
  left: 0;
  top: 50%;
  margin: 0;
  position: absolute;
  transform: translateY(-50%);
}

.answer-label {
  font-size: 12px;
  padding-left: 20px;
}

.form-tabs {
  display: flex;
}
.form-tabs > div {
  height: 50px;
  display: flex;
  padding: 15px;
  color: #676767;
  cursor: pointer;
  font-size: 12px;
  align-items: center;
  justify-content: center;
  border: 1px solid #E0E0E0;
  border-bottom: 0 none;
  background: linear-gradient(180deg, rgba(245, 245, 245, 0.2) 0%, #F5F5F5 100%);
}
.form-tabs > div:first-child {
  border-top-left-radius: 5px;
}
.form-tabs > div:last-child {
  border-left: 0 none;
  border-top-right-radius: 5px;
}
.form-tabs > div.active {
  color: #333;
  background: #fff;
  font-weight: 600;
  position: relative;
}
.form-tabs > div.active:after {
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  content: "";
  background: #fff;
  position: absolute;
  margin-bottom: -1px;
}
.form-tabs > div.disabled {
  cursor: auto;
  color: #BDBDBD;
}

.table-action-button {
  position: relative;
}
.table-action-button .text-button {
  right: 15px;
  bottom: 12px;
  position: absolute;
}

.auto-complete {
  margin-top: -1px;
  background: #fff;
  position: relative;
  padding: 7px 5px 7px 15px;
  border: 1px solid #E0E0E0;
}
.auto-complete > div {
  font-size: 12px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.auto-complete > div:last-child {
  margin-bottom: 0;
}
.auto-complete > div > div:first-child {
  padding: 7px 0;
}
.auto-complete .text-button {
  padding: 7px 10px;
  display: inline-block;
}

.is-capitalized {
  text-transform: capitalize;
}

.summary-table {
  width: 100%;
  font-size: 12px;
  margin-bottom: 30px;
}
.summary-table-row {
  cursor: pointer;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #E0E0E0;
}
.summary-table-row-tr {
  cursor: pointer;
  background: #fff;
  border-bottom: 1px solid #E0E0E0;
}
.summary-table .summary-cell {
  box-sizing: border-box;
  padding: 15px 10px 15px 0;
}
.summary-table .summary-cell.pl-m {
  padding-left: 10px;
}
.summary-table .summary-cell.center-x {
  padding-right: 0;
  text-align: center;
}
.summary-table .summary-cell.visibility-l {
  color: #4F4F4F;
  font-weight: 700;
}
.summary-table .summary-cell.summary-cell-w1 {
  width: 5%;
  flex-shrink: 0;
}
.summary-table .summary-cell.summary-cell-w2 {
  width: 10%;
  flex-shrink: 0;
}
.summary-table .summary-cell.summary-cell-w3 {
  width: 15%;
  flex-shrink: 0;
}
.summary-table .summary-cell.summary-cell-w4 {
  width: 20%;
  flex-shrink: 0;
}
.summary-table .summary-cell.summary-cell-fluid {
  flex-grow: 1;
}
.summary-table .summary-cell input[type=text] {
  padding: 0;
  width: 100%;
  border: 0 none;
  background: transparent;
}
.summary-table-head .summary-cell {
  padding: 0 0 6px;
}
.summary-table input {
  margin: 0;
}

.article-source {
  padding: 15px;
  font-size: 12px;
}
.article-source-top {
  margin-bottom: 3px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.article-source-title {
  color: #000;
  overflow: hidden;
  font-weight: 500;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.article-source-link {
  display: block;
  overflow: hidden;
  color: #2F80ED;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.article-source-label {
  color: #777;
}
.article-source-selector span {
  cursor: pointer;
  margin-left: 10px;
}
.article-source-selector span.active {
  font-weight: bold;
  color: #2F80ED;
}

.ai-polls-action {
  padding-top: 10px;
  text-align: center;
}
.ai-polls-action > * {
  margin: 0 10px;
  display: inline-block;
  vertical-align: middle;
}

/* Side nav */
.menuCollapseToggle {
  color: #4f4f4f;
  height: 68px;
  font-size: 22px;
  font-weight: 600;
  padding: 0 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.menuCollapseToggle svg {
  display: block;
}
@media (max-width: 767px) {
  .menuCollapseToggle {
    display: none;
  }
}

.main-left-col {
  width: 270px;
}

.main-right-col {
  width: calc(100% - 270px);
  padding: 0 60px;
}
@media (max-width: 767px) {
  .main-right-col {
    width: 100%;
    padding: 18px 18px 0;
  }
}

.side-nav-trigger {
  color: #4f4f4f;
  height: 54px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  position: relative;
  padding: 0 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.side-nav-trigger:before {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 5px;
  content: none;
  position: absolute;
  background: #2F80ED;
}
.side-nav-trigger figure {
  margin: 0;
  width: 40px;
}
.side-nav-trigger figure svg path {
  fill: #BDBDBD;
}
.side-nav-trigger > span {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.side-nav-trigger.active .icon-chevron-down, .side-nav-trigger.expanded .icon-chevron-down {
  transform: scaleY(-1);
}
.side-nav-trigger.active + ul, .side-nav-trigger.expanded + ul {
  display: block;
}
.side-nav-trigger.active {
  color: #2F80ED;
}
.side-nav-trigger.active:before {
  content: "";
}
.side-nav-trigger.active figure svg path {
  fill: #2F80ED;
}
.side-nav-trigger.active figure svg.has-stroke path {
  stroke: #2F80ED;
}
.side-nav ul {
  margin: 0;
  display: none;
  font-size: 14px;
  background: #F8F8F8;
  list-style-type: none;
  padding: 18px;
}
.side-nav ul li {
  margin-bottom: 15px;
}
.side-nav ul li:last-child {
  margin-bottom: 0;
}
.side-nav ul li a.active {
  font-weight: 700;
  color: #2F80ED;
}

.current-network-section {
  padding: 18px;
  border-top: 1px solid #E0E0E0;
  border-bottom: 1px solid #E0E0E0;
}

.standard-dropdown-label {
  color: #000;
  font-size: 14px;
  font-weight: 600;
}
.standard-dropdown-label + .dropdown {
  margin-top: 3px;
}

.standard-dropdown .is-active-option {
  background: #eee;
}
.standard-dropdown.color-purple > .dropdown > button:before, .standard-dropdown.color-green > .dropdown > button:before {
  width: 12px;
  height: 12px;
  content: "";
  margin-right: 8px;
  vertical-align: -1px;
  display: inline-block;
}
.standard-dropdown.color-purple > .dropdown > button:before {
  background: #8A10BE;
}
.standard-dropdown.color-green > .dropdown > button:before {
  background: #51DAAB;
}
.standard-dropdown > .dropdown > .dropdown-menu {
  padding-top: 8px;
}
.standard-dropdown > .dropdown > .dropdown-menu .custom-dropdown-search {
  top: -8px;
  margin-top: -8px;
  border-bottom: 1px solid #E0E0E0;
}
.standard-dropdown .is-underlined {
  border-bottom: 1px solid #E0E0E0;
}
.standard-dropdown input[type=checkbox] {
  margin: 0 5px 0 0;
  vertical-align: -2px;
}

/* End side nav */
.page-headline {
  width: 100%;
  height: 68px;
  color: #4f4f4f;
  font-size: 22px;
  margin: 0 0 18px;
  box-sizing: content-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid #E0E0E0;
}
.page-headline.is-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 767px) {
  .page-headline.is-flex {
    display: block;
  }
}
.page-headline .search-and-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
}
.page-headline strong {
  font-weight: 600;
}
@media (max-width: 767px) {
  .page-headline {
    height: auto;
    font-size: 18px;
    text-align: center;
    border-bottom: 0 none;
  }
  .page-headline > div:first-child {
    width: 100%;
    text-align: left;
    margin-bottom: 18px;
    padding-bottom: 18px;
    border-bottom: 1px solid #E0E0E0;
  }
  .page-headline .interval-selector {
    display: inline-block;
  }
  .page-headline .blue-button {
    justify-content: center;
  }
  .page-headline .search-and-buttons {
    display: block;
  }
}

.info-box {
  border-radius: 8px;
  border: 1px solid #E0E0E0;
  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.1019607843);
}
.info-box-header {
  font-size: 16px;
  font-weight: 600;
  padding: 12px 20px;
}
.info-box-header svg {
  margin-right: 10px;
}
.info-box-content {
  padding: 0 20px 15px;
}
.info-box-content .chart-box {
  padding: 0;
}
.info-box-footer {
  font-size: 14px;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #E0E0E0;
}
.info-box-footer .icon-chevron-down {
  vertical-align: 0;
  transform: rotate(-90deg);
}
.info-box-footer .icon-chevron-down path {
  fill: #2F80ED;
}
.info-box + .info-box, .info-box + .table-box, .info-box + .debates-box {
  margin-top: 25px;
}

.chart-controls {
  padding: 20px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.chart-controls > * {
  margin-right: 10px;
}

.chart-box {
  padding: 0 20px 20px;
}

.mid-selector {
  margin: 20px 0;
}
.mid-selector .standard-dropdown {
  max-width: 260px;
}

.table-box {
  margin-bottom: 25px;
  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.1019607843);
}
.table-box-header {
  font-size: 13px;
  padding: 12px 15px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #E0E0E0;
  border-bottom: 0 none;
}
.table-box-header .text-button {
  margin-right: 15px;
}
.table-box-actions {
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-box-actions .separator {
  width: 1px;
  height: 20px;
  margin: 0 20px;
  background: #E0E0E0;
}
.table-box-actions .text-button {
  margin-right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-box-actions .text-button svg {
  margin-right: 7px;
}
@media (max-width: 767px) {
  .table-box-actions .separator {
    display: none;
  }
  .table-box-actions .text-button {
    margin-left: 10px;
  }
  .table-box-actions .text-button span {
    display: none;
  }
}
.table-box-content {
  overflow: auto;
}
.table-box-title {
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.table-box-title svg {
  margin-right: 7px;
}
.table-box table {
  width: 100%;
}
.table-box table th, .table-box table td {
  padding: 8px 15px;
  border: 1px solid #E0E0E0;
}
.table-box table th {
  color: #000;
  cursor: pointer;
  font-size: 13px;
  font-weight: normal;
}
.table-box table th svg {
  margin-left: 5px;
  vertical-align: 1px;
}
.table-box table td {
  font-size: 12px;
  text-align: right;
}
.table-box table td:first-child {
  text-align: left;
}
.table-box table .totals-row td {
  color: #000;
  font-weight: 600;
  background: #E1E0E3;
}
.table-box-pagination {
  padding: 7px;
  font-size: 14px;
  text-align: center;
  border: 1px solid #E0E0E0;
  border-top: 0 none;
}

.debates-box {
  border-radius: 8px;
  margin-bottom: 25px;
  border: 1px solid #E0E0E0;
  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.1019607843);
}
.debates-box-title {
  padding: 12px 15px;
}
.debates-box-title h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}
.debates-box-content {
  padding: 20px 50px;
  background: linear-gradient(180deg, #E7E7E7 0%, #F8F8F8 100%);
}
.debates-box-list {
  overflow: auto;
  white-space: nowrap;
}
.debates-box-list .topDebate {
  white-space: normal;
}

.page-selectors {
  margin-bottom: 25px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
@media (max-width: 767px) {
  .page-selectors {
    display: block;
  }
}
.page-selectors .standard-dropdown {
  width: 260px;
  margin-right: 12px;
}
@media (max-width: 767px) {
  .page-selectors .standard-dropdown {
    margin: 0 0 10px;
    width: auto;
  }
}
.page-selectors .btn {
  font-size: 13px;
}
@media (max-width: 767px) {
  .page-selectors .btn {
    width: 100%;
  }
}

.info-stats {
  flex-wrap: wrap;
  text-align: center;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.info-stats > div {
  width: 24%;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 12px;
  box-sizing: border-box;
  background: #F6F6F6;
}
@media (max-width: 767px) {
  .info-stats > div {
    width: 48%;
  }
}
.info-stats .info-stat-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 3px;
}
.info-stats .info-stat-value {
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.info-stats .info-stat-value .no-change {
  width: 8px;
  height: 2px;
  margin: 0 2px 0 7px;
  display: inline-block;
  background: #828282;
}
.info-stats .info-stat-value svg {
  margin: 0 2px 0 7px;
}
.info-stats .info-stat-value span {
  font-size: 13px;
  color: #828282;
}

.change-down {
  transform: scaleY(-1);
}
.change-down path {
  fill: #ff0000;
}

.interval-selector {
  font-size: 14px;
  padding: 0 0 0 10px;
  border: 1px solid #2F80ED;
}
.interval-selector .fa:before {
  color: #2F80ED;
}
.interval-selector input {
  width: 200px;
  outline: none;
  border: 0 none;
  cursor: pointer;
  color: #2F80ED;
  text-align: center;
}
.interval-selector input.size-s {
  width: 150px;
}

.mega-form {
  width: 100%;
  max-width: 640px;
}
.mega-form-top {
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.mega-form-middle {
  margin-bottom: 10px;
}
.mega-form textarea {
  margin: 0;
  width: 100%;
  height: 500px;
  padding: 10px;
  display: block;
  font-size: 12px;
  border-radius: 10px;
  box-shadow: 1px 1px 4px #E0E0E0;
  border: 1px solid #E0E0E0;
}
@media (max-width: 767px) {
  .mega-form textarea {
    height: 320px;
  }
}
.mega-form-bottom {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.mega-form-bottom .blue-button {
  margin-left: 10px;
}

#webpack-dev-server-client-overlay {
  display: none;
}

.form-box {
  padding: 20px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
}
.form-box-title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 15px;
}
.form-box-title:last-child {
  margin-bottom: 0;
}
.form-box-description {
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
  margin-bottom: 15px;
}
.form-box-image {
  text-align: center;
  margin-bottom: 15px;
}
.form-box-image img {
  max-width: 100%;
  max-height: 120px;
}
.form-box-field {
  margin-bottom: 10px;
}
.form-box-field input {
  width: 100%;
  height: 40px;
  padding: 0 10px;
  font-size: 12px;
  background: #fff;
  border-radius: 5px;
  box-sizing: border-box;
  border: 1px solid #DBDBDB;
}
.form-box-submit {
  width: 100%;
  height: 40px;
  display: block;
  padding: 0 10px;
  font-weight: 700;
  border-radius: 5px;
  margin: 20px 0 15px;
  font-size: 12px !important;
}
.form-box-terms {
  font-size: 10px;
  line-height: 1.4;
  color: #9b9b9b;
  text-align: center;
}
.form-box-terms a {
  font-size: 10px;
  display: contents;
}`, "",{"version":3,"sources":["webpack://./src/App.sass"],"names":[],"mappings":"AAgDA;EACC,sBAAA;EACA,0BAAA;AA/CD;;AAiDA;EACC,eAAA;EACA,QAAA;EACA,OAAA;EACA,MAAA;AA9CD;;AAgDA;EACC,eAAA;AA7CD;AA+BE;EAaF;IAIE,eAAA;EA5CA;EA8CA;IACC,SAAA;EA5CD;EA8CC;IACC,gBAAA;EA5CF;AACF;;AA6CA;EACC,kBAAA;AA1CD;AAgBE;EAyBF;IAIE,aAAA;IACA,gBAtEgB;EA6BhB;AACF;;AA0CA;EACC,eAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;AAvCD;;AAyCA;EACC,sBAAA;AAtCD;;AAyCC;EACC,cAAA;AAtCF;;AAwCA;EACC,eAAA;AArCD;;AAuCA;EACC,SAAA;EACA,aAAA;AApCD;;AAsCA;EACC,kBAAA;AAnCD;;AAqCA;EACC,WAAA;EACA,YAAA;AAlCD;;AAoCA;EACC,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAjCD;;AAmCA;EACC,gBAAA;EAzEA,aAAA;EACA,mBAAA;EACA,8BAAA;AA0CD;;AAgCA;EACC,WAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;AA7BD;AA9CE;EAsEF;IAQE,oBAAA;EA5BA;AACF;AA6BC;EACC,cAAA;EACA,eAAA;EACA,kBAAA;AA3BF;AA4BE;EACC,gBAAA;EACA,gBAAA;EACA,kBAAA;AA1BH;AA2BG;EACC,iBAAA;AAzBJ;AA0BE;EACC,gBAAA;EACA,oBAAA;AAxBH;AAyBC;EACC,eAAA;AAvBF;;AAyBA;EACC,mBAAA;AAtBD;AAwBC;EACC,SAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AAtBF;AAwBE;EACC,iBAAA;AAtBH;;AAwBA;EACC,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AArBD;AAuBC;EACC,kBAAA;EACA,kBAAA;EACA,gBAAA;AArBF;AAsBE;EACC,WAAA;EACA,YAAA;AApBH;AAqBC;EACC,gBAAA;AAnBF;AAoBE;EACC,cAAA;AAlBH;;AAoBA;EACC,mBAAA;AAjBD;AAmBC;EACC,YAAA;EACA,eAAA;AAjBF;;AAmBA;EACC,cAAA;EACA,iBAAA;EACA,mBAAA;AAhBD;AAkBC;EACC,aAAA;EAnJD,aAAA;EACA,mBAAA;EACA,8BAAA;EAmJC,gCAAA;AAdF;AAgBE;EACC,kBAAA;AAdH;AAgBC;EACC,aAAA;EACA,mBAAA;AAdF;AAgBC;EACC,UAAA;AAdF;AAgBC;EACC,gBAAA;EACA,gBAAA;AAdF;AAgBE;EACC,YAAA;EACA,gBAAA;AAdH;AAgBC;EACC,WAAA;EACA,kBAAA;AAdF;AAgBC;EACC,YAAA;EACA,iBAAA;AAdF;AAgBE;EACC,WAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AAdH;AAeE;EACC,YAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AAbH;AAoBE;EACC,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AAlBH;;AAoBA;EACC,eAAA;EACA,eAAA;EACA,cArPY;AAoOb;;AAoBC;EACC,iBAAA;AAjBF;;AAkBA;EACC,0BAAA;AAfD;;AAgBA;EACC,kBAAA;AAbD;;AAeA;EACC,iBAAA;AAZD;;AAcA;EACC,UAAA;EACA,kBAAA;EACA,oBAAA;AAXD;;AAaA;EACC,8BAAA;AAVD;AAYC;EACC,cAAA;AAVF;;AAYA;EACC,aAAA;EACA,gBAAA;EACA,8BAAA;AATD;AAWC;EAEC,kBAAA;EACA,8BAAA;EACA,4BAAA;AAVF;AAYE;EACC,OAAA;EACA,QAAA;EACA,kBAAA;AAVH;AAWE;EACC,2BAAA;AATH;AAcC;EACC,WAAA;EACA,eAAA;EACA,iBAAA;AAZF;;AAcA;EACC,mBAAA;AAXD;AAYC;EACC,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAVF;AAWC;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AATF;AAUC;EACC,YAAA;AARF;;AAUA;EACC,WAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAPD;;AASA;EACC,YAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AAND;AAQC;EACC,WAAA;AANF;AAOC;EACC,mBAAA;EArSD,aAAA;EACA,mBAAA;EACA,8BAAA;AAiSD;AAIC;EACC,WAAA;EACA,eAAA;EACA,gBAAA;AAFF;AAGC;EACC,kBAAA;EACA,mBAAA;AADF;AAEE;EACC,WAAA;EACA,YAAA;AAAH;AACC;EACC,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AACF;AAAC;EACC,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAEF;AAAC;EACC,YAAA;EACA,cAAA;EACA,eAAA;AAEF;AACG;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AACJ;AACI;EACC,eAAA;EACA,mBAAA;AACL;AAAK;EACC,mBAAA;AAEN;AAAM;EACC,cAvXM;EAwXN,eAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,4BAAA;AAEP;AADI;EACC,iBAAA;EACA,oBAAA;AAGL;AAFI;EACC,oBAAA;AAIL;AAHG;EACC,WAAA;AAKJ;AAJG;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;AAMJ;AALI;EACC,oBAAA;AAOL;AANI;EACC,aAAA;AAQL;AAPI;EACC,mBAAA;AASL;AARI;EACC,iBAAA;AAUL;AATG;EACC,iBAAA;EACA,mBAAA;AAWJ;AAVG;EACC,aAAA;EACA,8BAAA;AAYJ;AAXI;EACC,SAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AAaL;AAZI;EACC,oBAAA;AAcL;AAbG;EAhYF,aAAA;EACA,uBAAA;EACA,8BAAA;AAgZD;AAhBI;EACC,UAAA;AAkBL;AAjBG;EACC,kBAAA;EACA,mBAAA;AAmBJ;AAlBI;EACC,mBAAA;AAoBL;AAnBI;EACC,SAAA;AAqBL;AApBI;EACC,QAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAsBL;AArBE;EACC,qBAAA;AAuBH;AAtBE;EACC,eAAA;EACA,mBAAA;AAwBH;AAvBG;EACC,cAAA;EACA,iBAAA;EACA,eAAA;AAyBJ;AAxBE;EACC,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AA0BH;AAzBG;EACC,aAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;AA2BJ;AA1BG;EACC,aAAA;AA4BJ;AA1BC;EACC,gBAAA;EACA,kBAAA;AA4BF;AA1BE;EACC,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAtdU;AAkfb;AA1BG;EACC,WAAA;EACA,mBA1dS;AAsfb;AA1BG;EACC,cAAA;EACA,cA9dS;EA+dT,uBAAA;EACA,yBAAA;AA4BJ;AA3BG;EACC,cAAA;EACA,mBAAA;AA6BJ;AA5BG;EACC,mBAAA;AA8BJ;AA5BE;EACC,aAAA;AA8BH;AA5BE;EACC,gBAAA;AA8BH;AA5BE;EACC,iBAAA;AA8BH;AA7BG;EACC,WAAA;EACA,iBAAA;AA+BJ;AA7BE;EACC,aAAA;EACA,8BAAA;AA+BH;AA7BG;EACC,UAAA;AA+BJ;AA7BC;EACC,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,0BAAA;AA+BF;AA7BE;EACC,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AA+BH;AA7BG;EACC,MAAA;EACA,OAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;AA+BJ;AA7BG;EACC,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AA+BJ;AA7BC;EACC,WAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AA+BF;AA7BC;EACC,eAAA;EACA,gBAAA;EACA,kBAAA;AA+BF;;AA7BA;EACC,aAAA;EACA,kBAAA;EACA,8BAAA;AAgCD;AA9BC;EACC,gBAAA;EACA,iBAAA;EACA,kBAAA;AAgCF;;AA9BA;EACC,WAAA;EACA,iBAAA;AAiCD;;AA/BA;EACC,aAAA;EACA,mBAAA;EACA,gCAAA;AAkCD;AAhCC;EACC,cAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gDAAA;AAkCF;AAhCE;EACC,2BAAA;AAkCH;AAjCE;EACC,4BAAA;AAmCH;AAlCE;EACC,cAAA;EACA,gBAAA;EACA,kBAAA;AAoCH;AAlCG;EACC,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAoCJ;;AAlCA;EACC,WAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAqCD;AAnCC;EACC,yBAAA;AAqCF;;AAnCA;EACC,gBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;AAsCD;;AApCA;EACC,WAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AAuCD;AArCC;EACC,UAAA;EACA,+BAAA;AAuCF;AArCE;EACC,eAAA;AAuCH;AArCC;EACC,cAAA;EACA,eAAA;AAuCF;;AArCA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;AAwCD;AAtCC;EACC,mBAAA;AAwCF;AAvCC;EACC,aAAA;EACA,mBAAA;AAyCF;;AAvCA;EACC,kBAAA;AA0CD;AAzCC;EACC,SAAA;EACA,UAAA;AA2CF;;AAxCC;EACC,eAAA;EACA,kBAAA;EACA,sBAAA;AA2CF;AA1CC;EACC,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAvpBW;EAwpBX,kBAAA;EACA,sBAAA;EACA,yBAAA;AA4CF;;AA1CA;EACC,kBAAA;AA6CD;AA5CC;EACC,QAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;AA8CF;AA7CC;EACC,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AA+CF;;AA7CA;EACC,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAgDD;AA9CE;EACC,iBAAA;AAgDH;AA/CC;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBA1rBiB;AA2uBnB;AAhDC;EACC,qBAAA;AAkDF;;AAhDA;EACC,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,qBAAA;AAmDD;;AAjDA;EACC,aAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;AAoDD;;AAlDA;EACC,iBAAA;EACA,kBAAA;AAqDD;AAnDC;EACC,YAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AAqDF;AAnDE;EACC,YAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAhuBgB;AAqxBnB;AAnDG;EACC,gBAAA;AAqDJ;AAnDE;EACC,WAAA;EACA,iBAAA;EACA,0BAAA;AAqDH;AAnDC;EACC,iBAAA;AAqDF;AAnDC;EACC,YAAA;AAqDF;AAlDE;EACC,WAAA;EACA,mBAtvBU;AA0yBb;AAjDI;EACC,UAAA;AAmDL;AAjDC;EACC,eAAA;AAmDF;AAjDC;EACC,OAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,2CAAA;EACA,UAAA;AAmDF;AAjDE;EACC,UAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AAmDH;AAjDG;EACC,eAAA;EACA,iBAAA;AAmDJ;AAjDI;EACC,kBAAA;EACA,mBAzxBU;AA40Bf;AAjDC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AAmDF;;AAjDA;EACC,cAAA;EACA,eAAA;AAoDD;AAlDC;EACC,6BAAA;AAoDF;;AAlDA;EACC,eAAA;EACA,8BAAA;AAqDD;AAnDC;EACC,eAAA;AAqDF;AAnDC;EACC,SAAA;AAqDF;AAlDC;EACC,iBAAA;AAoDF;;AAlDA;EACC,sBAAA;EACA,yBAAA;EACA,gCAAA;AAqDD;AAnDC;EACC,eAAA;EACA,gBAAA;AAqDF;AApDE;EACC,eAAA;AAsDH;AArDC;EACC,gBAAA;EACA,qBAAA;EACA,qBAAA;AAuDF;AAtDC;EACC,uBAAA;AAwDF;AAvDC;EACC,+BAAA;AAyDF;AAxDE;EACC,kBAAA;AA0DH;AAzDC;EACC,gBAAA;AA2DF;AAzDC;EACC,SAAA;EACA,sBAAA;AA2DF;AA1DC;EACC,WAAA;EACA,aAAA;EACA,sBAAA;AA4DF;;AA1DA;EACC,YAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AA6DD;;AA3DA;EACC,YAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AA8DD;;AA5DA;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBA72BY;EA82BZ,yBAAA;AA+DD;AA7DC;EACC,WAAA;AA+DF;AA9DC;EACC,YAAA;AAgEF;AA/DC;EACC,cAAA;EACA,mBAn3BiB;EAo3BjB,yBAAA;AAiEF;AAhEC;EACC,YAAA;EACA,eAAA;EACA,eAAA;AAkEF;AAjEC;EACC,gBAAA;EACA,cA93BW;AAi8Bb;AAlEC;EACC,iBAAA;EACA,qBAAA;AAoEF;AAnEE;EACC,iBAAA;AAqEH;AAnEC;EACC,kBAAA;EACA,oBAAA;AAqEF;;AAnEA;EACC,2BAAA;EACA,4BAAA;EACA,yBAAA;AAsED;AApEC;EACC,yBAAA;AAsEF;AApEC;EACC,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,gCAAA;AAsEF;AApEE;EACC,gBAAA;AAsEH;AArEG;EACC,YAAA;EACA,cAAA;AAuEJ;AArEC;EACC,wBAAA;AAuEF;AAtEE;EACC,uBAAA;AAwEH;AAvEC;EACC,mBAAA;AAyEF;AAxEE;EACC,mBAAA;AA0EH;AAzEE;EACC,kBAAA;EACA,mBAAA;AA2EH;AA1EG;EACC,eAAA;EACA,kBAAA;EACA,uBAAA;AA4EJ;AA3EG;EACC,QAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,2BAAA;AA6EJ;AA5EG;EACC,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;AA8EJ;AA7EE;EACC,cAAA;EACA,eAAA;EACA,kBAAA;AA+EH;AA9EG;EACC,cAAA;EACA,gBAAA;EACA,mBAAA;AAgFJ;AA/EG;EACC,cAj8BS;EAk8BT,eAAA;EACA,iBAAA;EACA,mBAAA;AAiFJ;AAhFE;EACC,YAAA;EACA,eAAA;EACA,kBAAA;AAkFH;AAjFC;EACC,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;AAmFF;AAjFE;EACC,mBAAA;EACA,qBAAA;AAmFH;AAlFE;EACC,MAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAoFH;AAnFE;EACC,gBAAA;AAqFH;AApFC;EACC,eAAA;EACA,eAAA;EACA,mBAAA;EA37BD,aAAA;EACA,mBAAA;EACA,8BAAA;EA27BC,6BAAA;EACA,gCAAA;AAwFF;AAvFE;EACC,cAAA;AAyFH;AAxFE;EACC,kBAAA;AA0FH;AAzFC;EACC,mBAAA;EACA,oBAAA;EACA,gCAAA;AA2FF;AA1FE;EACC,iBAAA;AA4FH;AA3FC;EACC,gBAAA;EACA,mBAAA;AA6FF;AA5FC;EACC,cAAA;AA8FF;AA7FC;EACC,aAAA;EACA,mBAAA;AA+FF;AA9FE;EACC,gBAAA;EACA,iBAAA;AAgGH;AA/FE;EACC,yBAAA;AAiGH;AAhGG;EACC,kBAAA;AAkGJ;AAhGE;EACC,WAAA;EACA,YAAA;AAkGH;AAjGG;EACC,UAAA;AAmGJ;;AAjGA;EACC,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;AAoGD;AAlGC;EACC,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;AAoGF;AAnGC;EACC,aAAA;EACA,uBAAA;AAqGF;AApGE;EACC,WAAA;AAsGH;;AApGA;EACC,kBAAA;EACA,kBAAA;AAuGD;AArGC;EACC,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,2BAAA;AAuGF;;AArGA;EACC,eAAA;EACA,kBAAA;AAwGD;;AAtGA;EACC,aAAA;AAyGD;AAvGC;EACC,YAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,8EAAA;AAyGF;AAvGE;EACC,2BAAA;AAyGH;AAxGE;EACC,mBAAA;EACA,4BAAA;AA0GH;AAzGE;EACC,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AA2GH;AA1GG;EACC,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AA4GJ;AA3GE;EACC,YAAA;EACA,cAAA;AA6GH;;AA3GA;EACC,kBAAA;AA8GD;AA5GC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AA8GF;;AA5GA;EACC,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AA+GD;AA7GC;EACC,eAAA;EACA,kBAAA;EA7jCD,aAAA;EACA,mBAAA;EACA,8BAAA;AA6qCD;AA/GE;EACC,gBAAA;AAiHH;AA/GE;EACC,cAAA;AAiHH;AA/GC;EACC,iBAAA;EACA,qBAAA;AAiHF;;AA/GA;EACC,0BAAA;AAkHD;;AAhHA;EACC,WAAA;EACA,eAAA;EACA,mBAAA;AAmHD;AAlHC;EACC,eAAA;EACA,gBAAA;EAnlCD,aAAA;EACA,mBAAA;EACA,8BAAA;EAmlCC,gCAAA;AAsHF;AArHC;EACC,eAAA;EACA,gBAAA;EACA,gCAAA;AAuHF;AAtHC;EACC,sBAAA;EACA,yBAAA;AAwHF;AAvHE;EACC,kBAAA;AAyHH;AAxHE;EACC,gBAAA;EACA,kBAAA;AA0HH;AAzHE;EACC,cAAA;EACA,gBAAA;AA2HH;AA1HE;EACC,SAAA;EACA,cAAA;AA4HH;AA3HE;EACC,UAAA;EACA,cAAA;AA6HH;AA5HE;EACC,UAAA;EACA,cAAA;AA8HH;AA7HE;EACC,UAAA;EACA,cAAA;AA+HH;AA9HE;EACC,YAAA;AAgIH;AA9HG;EACC,UAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;AAgIJ;AA9HE;EACC,gBAAA;AAgIH;AA/HC;EACC,SAAA;AAiIF;;AA/HA;EACC,aAAA;EACA,eAAA;AAkID;AAjIC;EACC,kBAAA;EAnoCD,aAAA;EACA,mBAAA;EACA,8BAAA;AAuwCD;AApIC;EACC,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAsIF;AArIC;EACC,cAAA;EACA,gBAAA;EACA,cArrCW;EAsrCX,mBAAA;EACA,uBAAA;AAuIF;AAtIC;EACC,WAAA;AAwIF;AAtIE;EACC,eAAA;EACA,iBAAA;AAwIH;AAvIG;EACC,iBAAA;EACA,cAhsCS;AAy0Cb;;AAvIA;EACC,iBAAA;EACA,kBAAA;AA0ID;AAxIC;EACC,cAAA;EACA,qBAAA;EACA,sBAAA;AA0IF;;AAxIA,aAAA;AACA;EACC,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EA1qCA,aAAA;EACA,mBAAA;EACA,8BAAA;AAszCD;AA5IC;EACC,cAAA;AA8IF;AArzCE;EA+pCF;IAWE,aAAA;EA+IA;AACF;;AA9IA;EACC,YAAA;AAiJD;;AA/IA;EACC,yBAAA;EACA,eAAA;AAkJD;AAn0CE;EA+qCF;IAIE,WAAA;IACA,oBAAA;EAoJA;AACF;;AAlJC;EACC,cAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EApsCD,aAAA;EACA,mBAAA;EACA,8BAAA;AA01CD;AAtJE;EACC,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,mBArvCU;AA64Cb;AAvJE;EACC,SAAA;EACA,WAAA;AAyJH;AAvJI;EACC,aAAA;AAyJL;AAxJE;EArtCD,aAAA;EACA,mBAAA;EACA,8BAAA;AAg3CD;AA1JG;EACC,qBAAA;AA4JJ;AA3JG;EACC,cAAA;AA6JJ;AA5JE;EACC,cApwCU;AAk6Cb;AA7JG;EACC,WAAA;AA+JJ;AA5JK;EACC,aA1wCO;AAw6Cb;AA5JM;EACC,eA7wCM;AA26Cb;AA5JC;EACC,SAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAhxCgB;AA86ClB;AA7JE;EACC,mBAAA;AA+JH;AA9JG;EACC,gBAAA;AAgKJ;AA9JI;EACC,gBAAA;EACA,cA7xCQ;AA67Cb;;AA9JA;EACC,aA3xCiB;EA4xCjB,6BAAA;EACA,gCAAA;AAiKD;;AA/JA;EACC,WAAA;EACA,eAAA;EACA,gBAAA;AAkKD;AAjKC;EACC,eAAA;AAmKF;;AAhKC;EACC,gBAAA;AAmKF;AAjKE;EACC,WAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;AAmKH;AAhKE;EACC,mBAAA;AAkKH;AA/JE;EACC,mBAAA;AAiKH;AA9JE;EACC,gBAAA;AAgKH;AA/JG;EACC,SAAA;EACA,gBAAA;EACA,gCAAA;AAiKJ;AA/JC;EACC,gCAAA;AAiKF;AA/JC;EACC,iBAAA;EACA,oBAAA;AAiKF;;AA/JA,iBAAA;AAEA;EACC,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EAx0CA,aAAA;EACA,mBAAA;EACA,2BAAA;EAw0CA,gCAAA;AAmKD;AAjKC;EAnzCA,aAAA;EACA,mBAAA;EACA,8BAAA;AAu9CD;AAn9CE;EA6yCD;IAGE,cAAA;EAuKD;AACF;AAtKC;EAl0CA,aAAA;EACA,mBAAA;EACA,uBAAA;AA2+CD;AAxKC;EACC,gBAAA;AA0KF;AAh+CE;EAmyCF;IAsBE,YAAA;IACA,eAAA;IACA,kBAAA;IACA,qBAAA;EA2KA;EAzKA;IACC,WAAA;IACA,gBAAA;IACA,mBAz2Ce;IA02Cf,oBA12Ce;IA22Cf,gCAAA;EA2KD;EAzKA;IACC,qBAAA;EA2KD;EA1KA;IACC,uBAAA;EA4KD;EA3KA;IACC,cAAA;EA6KD;AACF;;AA5KA;EACC,kBAAA;EACA,yBAAA;EACA,uDAAA;AA+KD;AA7KC;EACC,eAAA;EACA,gBAAA;EACA,kBAAA;AA+KF;AA9KE;EACC,kBAAA;AAgLH;AA/KC;EACC,oBAAA;AAiLF;AAhLE;EACC,UAAA;AAkLH;AAjLC;EACC,eAAA;EACA,kBAAA;EAn2CD,aAAA;EACA,mBAAA;EACA,8BAAA;EAm2CC,6BAAA;AAqLF;AAnLE;EACC,iBAAA;EACA,yBAAA;AAqLH;AAnLG;EACC,aAn5CS;AAwkDb;AAlLE;EACC,gBAAA;AAoLH;;AAlLA;EACC,aAAA;EACA,eAAA;EA74CA,aAAA;EACA,mBAAA;EACA,2BAAA;AAmkDD;AArLC;EACC,kBAAA;AAuLF;;AArLA;EACC,oBAAA;AAwLD;;AAtLA;EACC,cAAA;AAyLD;AAxLC;EACC,gBAAA;AA0LF;;AAxLA;EACC,mBAAA;EACA,uDAAA;AA2LD;AA1LC;EACC,eAAA;EACA,kBAAA;EACA,2BAAA;EACA,4BAAA;EAz4CD,aAAA;EACA,mBAAA;EACA,8BAAA;EAy4CC,yBAAA;EACA,qBAAA;AA8LF;AA7LE;EACC,kBAAA;AA+LH;AA9LC;EAz5CA,aAAA;EACA,mBAAA;EACA,uBAAA;AA0lDD;AAjME;EACC,UAAA;EACA,YAAA;EACA,cAAA;EACA,mBA17CY;AA6nDf;AAlME;EACC,eAAA;EAj6CF,aAAA;EACA,mBAAA;EACA,uBAAA;AAsmDD;AArMG;EACC,iBAAA;AAuMJ;AA3lDE;EAs5CC;IACC,aAAA;EAwMF;EAvMC;IACC,iBAAA;EAyMF;EAxME;IACC,aAAA;EA0MH;AACF;AA1MC;EACC,cAAA;AA4MF;AA1MC;EACC,eAAA;EA/7CD,aAAA;EACA,mBAAA;EACA,2BAAA;AA4oDD;AA7ME;EACC,iBAAA;AA+MH;AA9MC;EACC,WAAA;AAgNF;AA/ME;EACC,iBAAA;EACA,yBAAA;AAiNH;AAhNE;EACC,WAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;AAkNH;AAjNG;EACC,gBAAA;EACA,mBAAA;AAmNJ;AAlNE;EACC,eAAA;EACA,iBAAA;AAoNH;AAnNG;EACC,gBAAA;AAqNJ;AAnNG;EACC,WAAA;EACA,gBAAA;EACA,mBAAA;AAqNJ;AApNC;EACC,YAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAsNF;;AApNA;EACC,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uDAAA;AAuND;AArNC;EACC,kBAAA;AAuNF;AAtNE;EACC,SAAA;EACA,eAAA;EACA,gBAAA;AAwNH;AAvNC;EACC,kBAAA;EACA,6DAAA;AAyNF;AAxNC;EACC,cAAA;EACA,mBAAA;AA0NF;AAzNE;EACC,mBAAA;AA2NH;;AAzNA;EACC,mBAAA;EA5/CA,aAAA;EACA,uBAAA;EACA,2BAAA;AAytDD;AAvrDE;EAu9CF;IAKE,cAAA;EA+NA;AACF;AA9NC;EACC,YAAA;EACA,kBAAA;AAgOF;AAhsDE;EA89CD;IAKE,gBAAA;IACA,WAAA;EAiOD;AACF;AAhOC;EACC,eAAA;AAkOF;AAzsDE;EAs+CD;IAIE,WAAA;EAmOD;AACF;;AAlOA;EACC,eAAA;EACA,kBAAA;EAz/CA,aAAA;EACA,uBAAA;EACA,8BAAA;AA+tDD;AArOC;EACC,UAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAjiDiB;AAwwDnB;AA9tDE;EAi/CD;IASE,UAAA;EAwOD;AACF;AAvOC;EACC,eAAA;EACA,gBAAA;EACA,kBAAA;AAyOF;AAvOC;EACC,eAAA;EAlhDD,aAAA;EACA,mBAAA;EACA,uBAAA;AA4vDD;AAzOE;EACC,UAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAtjDU;AAiyDb;AAzOE;EACC,mBAAA;AA2OH;AA1OE;EACC,eAAA;EACA,cA5jDU;AAwyDb;;AA1OA;EACC,qBAAA;AA6OD;AA5OC;EACC,aAAA;AA8OF;;AA5OA;EACC,eAAA;EACA,mBAAA;EACA,yBAAA;AA+OD;AA5OE;EACC,cA3kDU;AAyzDb;AA7OC;EACC,YAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,cAjlDW;EAklDX,kBAAA;AA+OF;AA9OE;EACC,YAAA;AAgPH;;AA9OA;EACC,WAAA;EACA,gBAAA;AAiPD;AAhPC;EACC,kBAAA;EAvkDD,aAAA;EACA,mBAAA;EACA,yBAAA;AA0zDD;AAnPC;EACC,mBAAA;AAqPF;AApPC;EACC,SAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,+BAAA;EACA,yBAAA;AAsPF;AAhzDE;EAijDD;IAYE,aAAA;EAuPD;AACF;AAvPC;EAxlDA,aAAA;EACA,mBAAA;EACA,yBAAA;AAk1DD;AA1PE;EACC,iBAAA;AA4PH;;AA1PA;EACC,aAAA;AA6PD;;AA3PA;EACC,aAAA;EACA,0CAAA;AA8PD;AA5PC;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;AA8PF;AA5PE;EACC,gBAAA;AA8PH;AA5PC;EACC,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AA8PF;AA5PC;EACC,kBAAA;EACA,mBAAA;AA8PF;AA7PE;EACC,eAAA;EACA,iBAAA;AA+PH;AA7PC;EACC,mBAAA;AA+PF;AA7PE;EACC,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AA+PH;AA7PC;EACC,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;AA+PF;AA7PC;EACC,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA+PF;AA7PE;EACC,eAAA;EACA,iBAAA;AA+PH","sourcesContent":["$color-blue: #2F80ED\n$color-info: #828282\n$color-border: #E0E0E0\n$color-background: #F6F6F6\n\n$padding-sidebar: 18px\n$padding-main: 60px\n\n@mixin flex-start\n\tdisplay: flex\n\talign-items: flex-start\n\tjustify-content: flex-start\n\n@mixin flex-center-start\n\tdisplay: flex\n\talign-items: center\n\tjustify-content: flex-start\n\n@mixin flex-center-end\n\tdisplay: flex\n\talign-items: center\n\tjustify-content: flex-end\n\n@mixin flex-end-start\n\tdisplay: flex\n\talign-items: flex-end\n\tjustify-content: flex-start\n\n@mixin flex-center\n\tdisplay: flex\n\talign-items: center\n\tjustify-content: center\n\n@mixin flex-start-between\n\tdisplay: flex\n\talign-items: flex-start\n\tjustify-content: space-between\n\n@mixin flex-center-between\n\tdisplay: flex\n\talign-items: center\n\tjustify-content: space-between\n\n@mixin breakpoint($point: s)\n\t@if $point == s\n\t\t@media (max-width: 767px)\n\t\t\t@content\n\n.full-width\n\twidth: 100% !important\n\tmax-width: 100% !important\n\n.sticky-header\n\tposition: fixed\n\tright: 0\n\tleft: 0\n\ttop: 0\n\n.app-header\n\tpadding: 0 $padding-sidebar\n\n\t@include breakpoint\n\t\tpadding: 0 10px\n\n\t\t> .row\n\t\t\tmargin: 0\n\n\t\t\t.header-right-col\n\t\t\t\tpadding-right: 0\n\n.app-footer\n\tpadding: 12px $padding-sidebar\n\n\t@include breakpoint\n\t\tpadding: 10px\n\t\tmargin-top: $padding-sidebar\n\n.sticky-footer\n\tposition: fixed\n\tz-index: 10\n\tbottom: 0\n\tright: 0\n\tleft: 0\n\n.for-stickies\n\tpadding: 120px 0 100px\n\n.sticky-header, .sticky-footer, .for-stickies\n\t> *\n\t\tmargin: 0 30px\n\n.modal-header-x\n\tcursor: pointer\n\n.sided-modal-body\n\tmargin: 0\n\tpadding: 30px\n\n.padding-s\n\tpadding: 20px 25px\n\n.loader-top\n\tbottom: 0px\n\theight: auto\n\n.sided-modal-title\n\tcolor: #000\n\tfont-size: 16px\n\tfont-weight: 500\n\tmargin-bottom: 15px\n\n.sided-modal-footer\n\tmargin-top: 50px\n\t@include flex-center-between\n\n.sided-modal-checkers\n\tcolor: #000\n\tfont-size: 14px\n\tbackground: #F6F6F7\n\tmargin: 0 -25px 20px\n\tborder-top: 1px solid $color-border\n\n\t@include breakpoint\n\t\tmargin: 0 -15px 10px\n\n\t> div\n\t\tborder: 0 none\n\t\tpadding: 0 25px\n\t\tmargin-bottom: 7px\n\t\t&:first-child\n\t\t\tbackground: #fff\n\t\t\tmargin-bottom: 0\n\t\t\tpadding: 12px 25px\n\t\t\t+ div\n\t\t\t\tpadding-top: 20px\n\t\t&:last-child\n\t\t\tmargin-bottom: 0\n\t\t\tpadding-bottom: 20px\n\tlabel\n\t\tcursor: pointer\n\n.output-box\n\tmargin-bottom: 20px\n\n\th3\n\t\tmargin: 0\n\t\tdisplay: flex\n\t\tfont-size: 1.2em\n\t\talign-items: center\n\n\t\tsvg\n\t\t\tmargin-right: 5px\n\n.network-box\n\tdisplay: flex\n\tpadding: 18px 12px\n\tborder-radius: 7px\n\talign-items: center\n\tmargin-bottom: 20px\n\tbackground: #F7F7F7\n\n\t&-logo\n\t\tmargin-right: 10px\n\t\tborder-radius: 50%\n\t\toverflow: hidden\n\t\timg\n\t\t\twidth: 45px\n\t\t\theight: 45px\n\t&-text\n\t\tline-height: 1.1\n\t\tsmall\n\t\t\tcolor: #989898\n\n.sided-modal-search\n\tmargin-bottom: 20px\n\n\tinput\n\t\twidth: 360px\n\t\tmax-width: 100%\n\n.network-list\n\toverflow: auto\n\tmax-height: 370px\n\tmargin-bottom: 40px\n\n\t&-row\n\t\tpadding: 12px\n\t\t@include flex-center-between\n\t\tborder-bottom: 1px solid #F2F2F2\n\n\t\tlabel\n\t\t\tfont-size: inherit\n\n\t&-item\n\t\tdisplay: flex\n\t\talign-items: center\n\n\t&-name\n\t\twidth: 40%\n\n\t&-id\n\t\tline-height: 1.1\n\t\tmargin-left: 8px\n\n\t\tsmall\n\t\t\topacity: 0.7\n\t\t\tfont-size: 0.8em\n\n\t&-count\n\t\twidth: 90px\n\t\ttext-align: center\n\n\t&-buttons\n\t\tflex-grow: 1\n\t\ttext-align: right\n\n\t\t> .btn\n\t\t\twidth: auto\n\t\t\tfont-size: 14px\n\t\t\tmargin-right: 5px\n\t\t\tpadding: 7px 15px\n\t\t> select\n\t\t\twidth: 120px\n\t\t\theight: 37px\n\t\t\tpadding: 0 8px\n\t\t\tfont-size: 14px\n\t\t\tborder-radius: 6px\n\t\t\tvertical-align: middle\n\n\t&-logo\n\t\t//width: 26px\n\t\t//border-radius: 50%\n\t\t//box-sizing: content-box\n\t\t//border: 1px solid #D9D9D9\n\t\timg\n\t\t\twidth: 26px\n\t\t\theight: 26px\n\t\t\tdisplay: block\n\t\t\tobject-fit: cover\n\t\t\tborder-radius: 50%\n\t\t\tborder: 1px solid #D9D9D9\n\n.text-button\n\tcursor: pointer\n\tfont-size: 12px\n\tcolor: $color-blue\n\n.icon-right\n\tsvg\n\t\tmargin: 0 0 0 5px\n.underlined\n\ttext-decoration: underline\n.inherit-font\n\tfont-size: inherit\n\n> svg:first-child\n\tmargin-right: 5px\n\ninput.sided-checkbox\n\tpadding: 0\n\tmargin: 0 12px 0 0\n\tvertical-align: -1px\n\n.standard-label\n\tfont-weight: normal !important\n\n\t.text-button\n\t\tfont-size: 1em\n\n.syndication-init\n\tdisplay: flex\n\tmargin-top: 10px\n\tjustify-content: space-between\n\n\tlabel\n\t\t//padding-left: 20px\n\t\tposition: relative\n\t\tmargin-bottom: -3px !important\n\t\tline-height: 16px !important\n\n\t\tinput\n\t\t\tleft: 0\n\t\t\ttop: 3px\n\t\t\tposition: absolute\n\t\tstrong\n\t\t\tfont-weight: 700 !important\n\n\t\t+ span\n\t\t\t//padding-left: 20px\n\n\t.btn\n\t\twidth: auto\n\t\tfont-size: 14px\n\t\tpadding: 7px 15px\n\n.default-formfield\n\tmargin-bottom: 20px\n\tlabel\n\t\tdisplay: block\n\t\tcolor: #4F4F4F\n\t\tfont-size: 12px\n\t\tfont-weight: 600\n\t\tmargin-bottom: 5px\n\ttextarea, select\n\t\twidth: 100%\n\t\theight: 40px\n\t\tpadding: 5px 10px\n\t\tborder-radius: 5px\n\t\tborder: 1px solid #D9D9D9\n\ttextarea\n\t\theight: 80px\n\n.pre-auth-box\n\tcolor: #333\n\tfont-size: 14px\n\ttext-align: center\n\tmargin-bottom: 25px\n\n.auth-box\n\twidth: 773px\n\tdisplay: flex\n\tmargin: 0 auto\n\tmax-width: 100%\n\tmin-height: 500px\n\tpadding: 30px 45px\n\tborder-radius: 5px\n\talign-items: center\n\tbackground: #F9F9F9\n\n\t&-inner\n\t\twidth: 100%\n\t&-header\n\t\tmargin-bottom: 30px\n\t\t@include flex-center-between\n\t&-step\n\t\tcolor: #333\n\t\tfont-size: 14px\n\t\tfont-weight: 700\n\t&-logo\n\t\ttext-align: center\n\t\tmargin-bottom: 18px\n\t\timg\n\t\t\twidth: 50px\n\t\t\theight: 50px\n\t&-title\n\t\tcolor: #333\n\t\tfont-size: 18px\n\t\tfont-weight: 700\n\t\tline-height: 1.2\n\t\ttext-align: center\n\t\tmargin-bottom: 30px\n\t&-subtitle\n\t\tfont-size: 14px\n\t\tmax-width: 580px\n\t\ttext-align: center\n\t\tmargin: 0 auto 30px\n\n\tform\n\t\twidth: 344px\n\t\tmargin: 0 auto\n\t\tmax-width: 100%\n\n\t\tfieldset\n\t\t\tlabel\n\t\t\t\tdisplay: block\n\t\t\t\tfont-size: 12px\n\t\t\t\tfont-weight: 600\n\t\t\t\tmargin-bottom: 5px\n\t\t\tinput\n\t\t\t\t&[type=text], &[type=email], &[type=tel], &[type=password]\n\t\t\t\t\tfont-size: 12px\n\t\t\t\t\tmargin-bottom: 10px\n\t\t\t\t\t&.mb2x\n\t\t\t\t\t\tmargin-bottom: 20px\n\t\t\t\t\t+ .input-group-prepend\n\t\t\t\t\t\t.input-group-text\n\t\t\t\t\t\t\tcolor: $color-info\n\t\t\t\t\t\t\tpadding: 0 10px\n\t\t\t\t\t\t\tfont-size: 12px\n\t\t\t\t\t\t\tline-height: 34px\n\t\t\t\t\t\t\tborder-top-left-radius: 0\n\t\t\t\t\t\t\tborder-bottom-left-radius: 0\n\t\t\t\t&[type=checkbox]\n\t\t\t\t\tmargin: 0 5px 0 0\n\t\t\t\t\tvertical-align: -2px\n\t\t\t\t+ .validation-error\n\t\t\t\t\tmargin: -10px 0 10px\n\t\t\t.textarea2\n\t\t\t\twidth: 100%\n\t\t\t.input-info\n\t\t\t\tfont-size: 12px\n\t\t\t\tline-height: 1.3\n\t\t\t\tmargin: -7px 0 10px\n\t\t\t\t&.after-mb2x\n\t\t\t\t\tmargin: -17px 0 20px\n\t\t\t\t&.mt0\n\t\t\t\t\tmargin-top: 0\n\t\t\t\t&.mb2x\n\t\t\t\t\tmargin-bottom: 20px\n\t\t\t\t+ .validation-error\n\t\t\t\t\tmargin-top: -10px\n\t\t\t.input-button\n\t\t\t\ttext-align: right\n\t\t\t\tmargin-bottom: 20px\n\t\t\t&.code-fields\n\t\t\t\tdisplay: flex\n\t\t\t\tjustify-content: space-between\n\t\t\t\tinput\n\t\t\t\t\tmargin: 0\n\t\t\t\t\twidth: 48px\n\t\t\t\t\theight: 58px\n\t\t\t\t\tfont-size: 18px\n\t\t\t\t\tmax-width: 16.6%\n\t\t\t\t\tfont-weight: 700\n\t\t\t\t\ttext-align: center\n\t\t\t\t\tdisplay: inline-block\n\t\t\t\t+ .end-option\n\t\t\t\t\tmargin-bottom: 100px\n\t\t\t.two-fields\n\t\t\t\t@include flex-start-between\n\t\t\t\t> div\n\t\t\t\t\twidth: 48%\n\t\t\t.multi-field\n\t\t\t\tposition: relative\n\t\t\t\tmargin-bottom: 10px\n\t\t\t\t&.mb2x\n\t\t\t\t\tmargin-bottom: 20px\n\t\t\t\tinput\n\t\t\t\t\tmargin: 0\n\t\t\t\tspan\n\t\t\t\t\ttop: 5px\n\t\t\t\t\tright: 10px\n\t\t\t\t\tcursor: pointer\n\t\t\t\t\tposition: absolute\n\t\t.validation-error\n\t\t\twhite-space: pre-line\n\t\t.multi-check\n\t\t\tfont-size: 11px\n\t\t\tmargin-bottom: 10px\n\t\t\tlabel\n\t\t\t\tfont-size: 1em\n\t\t\t\tmargin-left: 10px\n\t\t\t\tdisplay: inline\n\t\t.text-line\n\t\t\tdisplay: block\n\t\t\tcolor: #9B9B9B\n\t\t\tfont-size: 10px\n\t\t\tmargin-top: 25px\n\t\t\ttext-align: center\n\t\t\twhite-space: nowrap\n\t\t\ta, .text-button\n\t\t\t\tmargin: 0 5px\n\t\t\t\tcolor: #9B9B9B\n\t\t\t\tdisplay: inline\n\t\t\t\ttext-decoration: underline\n\t\t\t&.mt0\n\t\t\t\tmargin-top: 0\n\n\t.button-holder\n\t\tmargin-top: 25px\n\t\ttext-align: center\n\n\t\tbutton, .button\n\t\t\tcolor: #fff\n\t\t\twidth: 244px\n\t\t\tborder: 0 none\n\t\t\tfont-size: 12px\n\t\t\tpadding: 10px 0\n\t\t\tborder-radius: 5px\n\t\t\ttext-align: center\n\t\t\tbackground: $color-blue\n\n\t\t\t&:hover\n\t\t\t\tcolor: #fff\n\t\t\t\tbackground: $color-blue\n\n\t\t\t&.bordered\n\t\t\t\tpadding: 9px 0\n\t\t\t\tcolor: $color-blue\n\t\t\t\tbackground: transparent\n\t\t\t\tborder: 1px solid $color-blue\n\t\t\t&.grayed\n\t\t\t\tcolor: #BDBDBD\n\t\t\t\tbackground: #F2F2F2\n\t\t\t&.green\n\t\t\t\tbackground: #27AE60\n\n\t\t&.mt0\n\t\t\tmargin-top: 0\n\n\t\t&.mtl\n\t\t\tmargin-top: 35px\n\n\t\t&.has-two\n\t\t\ttext-align: right\n\t\t\tbutton\n\t\t\t\twidth: 80px\n\t\t\t\tmargin-left: 10px\n\n\t\t&.has-halfs\n\t\t\tdisplay: flex\n\t\t\tjustify-content: space-between\n\n\t\t\tbutton, .button\n\t\t\t\twidth: 48%\n\n\t.logo-uploader\n\t\twidth: 64px\n\t\tpadding: 5px\n\t\tcursor: pointer\n\t\tbackground: #fff\n\t\tborder-radius: 50%\n\t\tbox-sizing: content-box\n\t\tborder: 1px dashed $color-info\n\n\t\t&-inner\n\t\t\theight: 64px\n\t\t\tdisplay: flex\n\t\t\toverflow: hidden\n\t\t\tposition: relative\n\t\t\tborder-radius: 50%\n\t\t\tbackground: #EBEBEB\n\t\t\talign-items: center\n\t\t\tjustify-content: center\n\n\t\t\tinput\n\t\t\t\ttop: 0\n\t\t\t\tleft: 0\n\t\t\t\tz-index: 5\n\t\t\t\topacity: 0\n\t\t\t\tposition: absolute\n\t\t\t\ttransform: scale(10)\n\n\t\t\timg\n\t\t\t\ttop: 0\n\t\t\t\tleft: 0\n\t\t\t\tz-index: 4\n\t\t\t\twidth: 100%\n\t\t\t\theight: 100%\n\t\t\t\tobject-fit: cover\n\t\t\t\tposition: absolute\n\n\t.logo-uploader-note\n\t\twidth: 76px\n\t\tcolor: #BDBDBD\n\t\tfont-size: 11px\n\t\ttext-align: center\n\n\t.end-option\n\t\tfont-size: 12px\n\t\tmargin-top: 25px\n\t\ttext-align: center\n\n.alt-option\n\tdisplay: flex\n\tmargin: 5px 0 25px\n\tjustify-content: space-between\n\n\t&.mw360\n\t\tmax-width: 360px\n\t\tmargin-left: auto\n\t\tmargin-right: auto\n\n.status-label\n\tcolor: #888\n\tmargin: 0 5px 0 0\n\n.modal-tabs\n\tdisplay: flex\n\tmargin-bottom: 30px\n\tborder-bottom: 1px solid #E4E4E4\n\n\t.modal-tab\n\t\tcolor: #5A9AF0\n\t\tcursor: pointer\n\t\tpadding: 15px 40px\n\t\tborder: 1px solid #E4E4E4\n\t\tborder-bottom: 0 none\n\t\tbackground-image: linear-gradient(#fff, $color-background)\n\n\t\t&:first-child\n\t\t\tborder-top-left-radius: 5px\n\t\t&:last-child\n\t\t\tborder-top-right-radius: 5px\n\t\t&.active\n\t\t\tcolor: #787878\n\t\t\tbackground: #fff\n\t\t\tposition: relative\n\n\t\t\t&:after\n\t\t\t\tleft: 0\n\t\t\t\tright: 0\n\t\t\t\ttop: 100%\n\t\t\t\theight: 1px\n\t\t\t\tcontent: ''\n\t\t\t\tbackground: #fff\n\t\t\t\tposition: absolute\n\n.page-title\n\tcolor: #000\n\tfont-size: 22px\n\tline-height: 1.36\n\tmargin-bottom: 30px\n\n\t&.uppercase\n\t\ttext-transform: uppercase\n\n.section-title\n\tfont-weight: 600\n\tcolor: #000 !important\n\tfont-size: 14px !important\n\tmargin: 0 0 20px !important\n\tline-height: 1.36 !important\n\n.general-stats\n\tcolor: #000\n\tdisplay: flex\n\tpadding: 18px 0\n\tfont-size: 13px\n\tmargin: 0 0 30px\n\tfont-weight: 600\n\ttext-align: center\n\tborder-radius: 4px\n\tbackground: #FAFAFA\n\n\t> div\n\t\twidth: 25%\n\t\tborder-right: 1px solid $color-border\n\n\t\t&:last-child\n\t\t\tborder-right: 0\n\n\t&-value\n\t\tcolor: #2F80ED\n\t\tfont-size: 28px\n\n.table-filters\n\tdisplay: flex\n\tmargin-bottom: 18px\n\tjustify-content: space-between\n\n\t&.mb-xl\n\t\tmargin-bottom: 45px\n\t&-start\n\t\tdisplay: flex\n\t\talign-items: center\n\n.table-checker\n\tmargin-right: 15px\n\tinput\n\t\tmargin: 0\n\t\tpadding: 0\n\n.table-sorter\n\tlabel\n\t\tfont-size: 14px\n\t\tmargin-right: 10px\n\t\tvertical-align: middle\n\tselect\n\t\theight: 28px\n\t\tpadding: 0 5px\n\t\tfont-size: 11px\n\t\tfont-weight: 600\n\t\tcolor: $color-blue\n\t\tborder-radius: 3px\n\t\tvertical-align: middle\n\t\tborder: 1px solid $color-blue\n\n.table-search\n\tposition: relative\n\tsvg\n\t\ttop: 50%\n\t\tleft: 13px\n\t\tmargin-top: -9px\n\t\tposition: absolute\n\tinput\n\t\twidth: 430px\n\t\theight: 40px\n\t\tfont-size: 12px\n\t\tbackground: #fff\n\t\tborder-radius: 4px\n\t\tpadding: 0 0 0 40px\n\t\tbox-sizing: border-box\n\n.table-pagination\n\tdisplay: flex\n\tcolor: #4F4F4F\n\tfont-size: 12px\n\tfont-weight: 600\n\talign-items: center\n\t> span\n\t\t+ span\n\t\t\tmargin-left: 10px\n\t&-nav\n\t\twidth: 34px\n\t\theight: 34px\n\t\tdisplay: flex\n\t\tcursor: pointer\n\t\tborder-radius: 4px\n\t\talign-items: center\n\t\tjustify-content: center\n\t\tbackground: $color-background\n\t&-prev\n\t\ttransform: scaleX(-1)\n\n.table-holder\n\tborder-top-left-radius: 5px\n\tborder-top-right-radius: 5px\n\tborder: 1px solid $color-border\n\tborder-bottom: 0 none\n\n.table-selectors\n\tdisplay: flex\n\tfont-size: 11px\n\tpadding: 6px 10px\n\tborder-bottom: 1px solid $color-border\n\n.table-control\n\tmargin-right: 6px\n\tposition: relative\n\n\t&-value\n\t\theight: 40px\n\t\tdisplay: flex\n\t\tcursor: pointer\n\t\tpadding: 0 16px\n\t\tfont-weight: 600\n\t\tborder-radius: 4px\n\t\talign-items: center\n\t\tbackground: #F2F2F2\n\n\t\t.selected-value\n\t\t\theight: 28px\n\t\t\tdisplay: flex\n\t\t\tcolor: #4F4F4F\n\t\t\tpadding: 0 10px\n\t\t\tmargin-left: 10px\n\t\t\tborder-radius: 4px\n\t\t\talign-items: center\n\t\t\tbackground: $color-background\n\n\t\t\tsvg\n\t\t\t\tmargin-left: 8px\n\n\t\t.quick-link\n\t\t\tcolor: #fff\n\t\t\tmargin-left: 20px\n\t\t\ttext-decoration: underline\n\n\t&-arrow\n\t\tmargin-left: 10px\n\n\t&.growing\n\t\tflex-grow: 1\n\n\t&.active\n\t\t.table-control-value\n\t\t\tcolor: #fff\n\t\t\tbackground: $color-blue\n\n\t\t\tsvg\n\t\t\t\tpath\n\t\t\t\t\tfill: #fff\n\n\t&:last-child\n\t\tmargin-right: 0\n\n\t.table-control-dropdown\n\t\tleft: 0\n\t\tright: auto\n\t\ttop: 100%\n\t\tz-index: 10\n\t\twidth: 360px\n\t\tfont-size: 13px\n\t\tbackground: #fff\n\t\tpadding: 20px 15px\n\t\tposition: absolute\n\t\tbox-sizing: border-box\n\t\tborder: 1px solid $color-border\n\t\tbox-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25)\n\t\tz-index: 9\n\n\t\tul\n\t\t\tpadding: 0\n\t\t\toverflow: auto\n\t\t\tmargin: 12px 0 0\n\t\t\tmax-height: 180px\n\t\t\tlist-style-type: none\n\n\t\t\tli\n\t\t\t\tcursor: pointer\n\t\t\t\tpadding: 5px 12px\n\n\t\t\t\t&:hover\n\t\t\t\t\tborder-radius: 4px\n\t\t\t\t\tbackground: $color-border\n\n\t.icon-export\n\t\twidth: 12px\n\t\theight: 17px\n\t\tmargin-right: 10px\n\n.table-body\n\toverflow: auto\n\tmin-width: 100%\n\n\t&.top-border\n\t\tborder-top: 1px solid $color-border\n\n.table-row\n\tfont-size: 14px\n\tjustify-content: space-between\n\n\t&.font-size-x\n\t\tfont-size: 12px\n\n\t.table-row-checkbox\n\t\tmargin: 0\n\n\t.blue-button\n\t+ .blue-button\n\t\tmargin-left: 10px\n\n.table-cell\n\tbox-sizing: border-box\n\tpadding: 15px 15px 15px 0\n\tborder-bottom: 1px solid $color-border\n\n\t&-labelled\n\t\tfont-size: 11px\n\t\tline-height: 1.3\n\t\tstrong\n\t\t\tfont-size: 14px\n\t&-text\n\t\tmax-width: 200px\n\t\tdisplay: inline-block\n\t\tword-wrap: break-word\n\t&.x-center\n\t\tjustify-content: center\n\t&.border-right\n\t\tborder-right: 1px solid $color-border\n\t\t+ .table-cell\n\t\t\tpadding-left: 10px\n\t&.padding-r-0\n\t\tpadding-right: 0\n\n\tinput\n\t\tmargin: 0\n\t\tvertical-align: middle\n\t.inline-buttons\n\t\twidth: 100%\n\t\tdisplay: flex\n\t\tjustify-content: right\n\n.select-box\n\theight: 40px\n\tpadding: 0 10px\n\tfont-size: 12px\n\tborder-radius: 4px\n\tborder: 1px solid $color-border\n\n.input-box\n\theight: 40px\n\tpadding: 0 10px\n\tfont-size: 12px\n\tborder-radius: 4px\n\tborder: 1px solid $color-border\n\n.blue-button\n\tcolor: #fff\n\theight: 38px\n\tdisplay: flex\n\tcursor: pointer\n\tpadding: 0 15px\n\tfont-size: 12px\n\tborder-radius: 4px\n\talign-items: center\n\tbackground: $color-blue\n\tborder: 1px solid $color-blue\n\n\t&:hover\n\t\tcolor: #fff\n\t&[disabled]\n\t\topacity: 0.5\n\t&.gray\n\t\tcolor: #959595\n\t\tbackground: $color-background\n\t\tborder: 1px solid $color-background\n\t&.size-l\n\t\theight: 50px\n\t\tpadding: 0 30px\n\t\tfont-size: 14px\n\t&.bordered\n\t\tbackground: #fff\n\t\tcolor: $color-blue\n\t&.inline\n\t\tline-height: 38px\n\t\tdisplay: inline-block\n\t\t&.bordered\n\t\t\tline-height: 36px\n\n\tsvg\n\t\tmargin-right: 10px\n\t\tvertical-align: -5px\n\n.segment-form\n\tborder-top-left-radius: 5px\n\tborder-top-right-radius: 5px\n\tborder: 1px solid $color-border\n\n\t&.after-tabs\n\t\tborder-top-left-radius: 0\n\n\theader\n\t\tz-index: 5\n\t\tpadding: 6px\n\t\tdisplay: flex\n\t\tbackground: transparent\n\t\tjustify-content: space-between\n\t\tborder-bottom: 1px solid $color-border\n\n\t\t> *\n\t\t\tmargin-left: 7px\n\t\t\t&:first-child\n\t\t\t\tflex-grow: 1\n\t\t\t\tmargin-left: 0\n\n\t&-body\n\t\tpadding: 25px 40px 100px\n\t\t&.padding-s\n\t\t\tpadding: 25px 45px 50px\n\t&-field\n\t\tmargin-bottom: 20px\n\t\t&.mb-l\n\t\t\tmargin-bottom: 40px\n\t\t.inner-dropdown\n\t\t\tposition: relative\n\t\t\tbackground: #FCFCFC\n\t\t\tinput[type=text]\n\t\t\t\tcursor: pointer\n\t\t\t\tposition: relative\n\t\t\t\tbackground: transparent\n\t\t\t.dropdown-arrow\n\t\t\t\ttop: 50%\n\t\t\t\tright: 16px\n\t\t\t\tcursor: pointer\n\t\t\t\tposition: absolute\n\t\t\t\ttransform: translateY(-50%)\n\t\t\t.auto-complete\n\t\t\t\tleft: 0\n\t\t\t\tright: 0\n\t\t\t\ttop: 100%\n\t\t\t\tposition: absolute\n\t\tlabel\n\t\t\tdisplay: block\n\t\t\tfont-size: 14px\n\t\t\tmargin-bottom: 5px\n\t\t\t&.type-2\n\t\t\t\tcolor: #4f4f4f\n\t\t\t\tfont-weight: 700\n\t\t\t\tmargin-bottom: 12px\n\t\t\t.info-note\n\t\t\t\tcolor: $color-info\n\t\t\t\tfont-size: 12px\n\t\t\t\tmargin-left: 20px\n\t\t\t\tfont-weight: normal\n\t\tinput\n\t\t\twidth: 300px\n\t\t\tfont-size: 12px\n\t\t\tpadding: 10px 15px\n\t&-picker\n\t\toverflow: hidden\n\t\tposition: relative\n\t\tvertical-align: top\n\t\tdisplay: inline-block\n\t&-image\n\t\t.blue-button\n\t\t\tvertical-align: top\n\t\t\tdisplay: inline-block\n\t\tinput\n\t\t\ttop: 0\n\t\t\tleft: 0\n\t\t\tmargin: 0\n\t\t\tpadding: 0\n\t\t\topacity: 0\n\t\t\tdisplay: block\n\t\t\tcursor: pointer\n\t\t\tposition: absolute\n\t\t\ttransform: scale(3)\n\t\timg\n\t\t\tmax-width: 300px\n\t&-info\n\t\tfont-size: 14px\n\t\tpadding: 20px 0\n\t\tmargin-bottom: 20px\n\t\t@include flex-center-between\n\t\tborder-top: 1px solid $color-border\n\t\tborder-bottom: 1px solid $color-border\n\t\t.select-box\n\t\t\tmargin: 0 10px\n\t\tlabel\n\t\t\tfont-size: inherit\n\t&-condition\n\t\tmargin-bottom: 15px\n\t\tpadding-bottom: 20px\n\t\tborder-bottom: 1px solid $color-border\n\t\t.select-box, .input-box\n\t\t\tmargin-right: 6px\n\t&-match\n\t\tfont-weight: 700\n\t\tmargin-bottom: 15px\n\t&-plus\n\t\tmargin: 24px 0\n\t&-buttons\n\t\tdisplay: flex\n\t\talign-items: center\n\t\t> *\n\t\t\tfont-weight: 700\n\t\t\tmargin-right: 8px\n\t\t&.align-right\n\t\t\tjustify-content: flex-end\n\t\t\t> *\n\t\t\t\tmargin: 0 0 0 40px\n\t.blue-button\n\t\t.icon-export\n\t\t\twidth: 12px\n\t\t\theight: 17px\n\t\t\tpath\n\t\t\t\tfill: #fff\n\n.modal-cta\n\ttop: 0\n\tleft: 0\n\tright: 0\n\tbottom: 0\n\tz-index: 2000\n\tdisplay: flex\n\tposition: fixed\n\talign-items: center\n\tjustify-content: center\n\tbackground: rgba(0,0,0,0.5)\n\n\t&-inner\n\t\tbackground: #fff\n\t\ttext-align: center\n\t\tborder-radius: 10px\n\t\tpadding: 20px 20px 15px\n\t&-buttons\n\t\tdisplay: flex\n\t\tjustify-content: center\n\t\t.blue-button\n\t\t\tmargin: 5px\n\n.quiz-side\n\tposition: relative\n\tpadding-left: 20px\n\n\tinput[type=checkbox]\n\t\tleft: 0\n\t\ttop: 50%\n\t\tmargin: 0\n\t\tposition: absolute\n\t\ttransform: translateY(-50%)\n\n.answer-label\n\tfont-size: 12px\n\tpadding-left: 20px\n\n.form-tabs\n\tdisplay: flex\n\n\t> div\n\t\theight: 50px\n\t\tdisplay: flex\n\t\tpadding: 15px\n\t\tcolor: #676767\n\t\tcursor: pointer\n\t\tfont-size: 12px\n\t\talign-items: center\n\t\tjustify-content: center\n\t\tborder: 1px solid $color-border\n\t\tborder-bottom: 0 none\n\t\tbackground: linear-gradient(180deg, rgba(245, 245, 245, 0.2) 0%, #F5F5F5 100%)\n\n\t\t&:first-child\n\t\t\tborder-top-left-radius: 5px\n\t\t&:last-child\n\t\t\tborder-left: 0 none\n\t\t\tborder-top-right-radius: 5px\n\t\t&.active\n\t\t\tcolor: #333\n\t\t\tbackground: #fff\n\t\t\tfont-weight: 600\n\t\t\tposition: relative\n\t\t\t&:after\n\t\t\t\tleft: 0\n\t\t\t\tright: 0\n\t\t\t\tbottom: 0\n\t\t\t\theight: 2px\n\t\t\t\tcontent: ''\n\t\t\t\tbackground: #fff\n\t\t\t\tposition: absolute\n\t\t\t\tmargin-bottom: -1px\n\t\t&.disabled\n\t\t\tcursor: auto\n\t\t\tcolor: #BDBDBD\n\n.table-action-button\n\tposition: relative\n\n\t.text-button\n\t\tright: 15px\n\t\tbottom: 12px\n\t\tposition: absolute\n\n.auto-complete\n\tmargin-top: -1px\n\tbackground: #fff\n\tposition: relative\n\tpadding: 7px 5px 7px 15px\n\tborder: 1px solid #E0E0E0\n\n\t> div\n\t\tfont-size: 12px\n\t\tborder-radius: 4px\n\t\t@include flex-center-between\n\n\t\t&:last-child\n\t\t\tmargin-bottom: 0\n\n\t\t> div:first-child\n\t\t\tpadding: 7px 0\n\n\t.text-button\n\t\tpadding: 7px 10px\n\t\tdisplay: inline-block\n\n.is-capitalized\n\ttext-transform: capitalize\n\n.summary-table\n\twidth: 100%\n\tfont-size: 12px\n\tmargin-bottom: 30px\n\t&-row\n\t\tcursor: pointer\n\t\tbackground: #fff\n\t\t@include flex-center-between\n\t\tborder-bottom: 1px solid #E0E0E0\n\t&-row-tr\n\t\tcursor: pointer\n\t\tbackground: #fff\n\t\tborder-bottom: 1px solid #E0E0E0\n\t.summary-cell\n\t\tbox-sizing: border-box\n\t\tpadding: 15px 10px 15px 0\n\t\t&.pl-m\n\t\t\tpadding-left: 10px\n\t\t&.center-x\n\t\t\tpadding-right: 0\n\t\t\ttext-align: center\n\t\t&.visibility-l\n\t\t\tcolor: #4F4F4F\n\t\t\tfont-weight: 700\n\t\t&.summary-cell-w1\n\t\t\twidth: 5%\n\t\t\tflex-shrink: 0\n\t\t&.summary-cell-w2\n\t\t\twidth: 10%\n\t\t\tflex-shrink: 0\n\t\t&.summary-cell-w3\n\t\t\twidth: 15%\n\t\t\tflex-shrink: 0\n\t\t&.summary-cell-w4\n\t\t\twidth: 20%\n\t\t\tflex-shrink: 0\n\t\t&.summary-cell-fluid\n\t\t\tflex-grow: 1\n\t\tinput\n\t\t\t&[type=text]\n\t\t\t\tpadding: 0\n\t\t\t\twidth: 100%\n\t\t\t\tborder: 0 none\n\t\t\t\tbackground: transparent\n\t&-head\n\t\t.summary-cell\n\t\t\tpadding: 0 0 6px\n\tinput\n\t\tmargin: 0\n\n.article-source\n\tpadding: 15px\n\tfont-size: 12px\n\t&-top\n\t\tmargin-bottom: 3px\n\t\t@include flex-center-between\n\t&-title\n\t\tcolor: #000\n\t\toverflow: hidden\n\t\tfont-weight: 500\n\t\twhite-space: nowrap\n\t\ttext-overflow: ellipsis\n\t&-link\n\t\tdisplay: block\n\t\toverflow: hidden\n\t\tcolor: $color-blue\n\t\twhite-space: nowrap\n\t\ttext-overflow: ellipsis\n\t&-label\n\t\tcolor: #777\n\t&-selector\n\t\tspan\n\t\t\tcursor: pointer\n\t\t\tmargin-left: 10px\n\t\t\t&.active\n\t\t\t\tfont-weight: bold\n\t\t\t\tcolor: $color-blue\n\n.ai-polls-action\n\tpadding-top: 10px\n\ttext-align: center\n\n\t> *\n\t\tmargin: 0 10px\n\t\tdisplay: inline-block\n\t\tvertical-align: middle\n\n/* Side nav */\n.menuCollapseToggle\n\tcolor: #4f4f4f\n\theight: 68px\n\tfont-size: 22px\n\tfont-weight: 600\n\tpadding: 0 $padding-sidebar\n\t@include flex-center-between\n\tsvg\n\t\tdisplay: block\n\n\t@include breakpoint\n\t\tdisplay: none\n\n.main-left-col\n\twidth: 270px\n\n.main-right-col\n\twidth: calc(100% - 270px)\n\tpadding: 0 $padding-main\n\t@include breakpoint\n\t\twidth: 100%\n\t\tpadding: $padding-sidebar $padding-sidebar 0\n\n.side-nav\n\t&-trigger\n\t\tcolor: #4f4f4f\n\t\theight: 54px\n\t\tcursor: pointer\n\t\tfont-size: 16px\n\t\tfont-weight: 600\n\t\tposition: relative\n\t\tpadding: 0 $padding-sidebar\n\t\t@include flex-center-between\n\t\t&:before\n\t\t\ttop: 0\n\t\t\tleft: 0\n\t\t\tright: 0\n\t\t\tbottom: 0\n\t\t\twidth: 5px\n\t\t\tcontent: none\n\t\t\tposition: absolute\n\t\t\tbackground: $color-blue\n\t\tfigure\n\t\t\tmargin: 0\n\t\t\twidth: 40px\n\t\t\tsvg\n\t\t\t\tpath\n\t\t\t\t\tfill: #BDBDBD\n\t\t> span\n\t\t\t@include flex-center-between\n\t\t&.active, &.expanded\n\t\t\t.icon-chevron-down\n\t\t\t\ttransform: scaleY(-1)\n\t\t\t+\tul\n\t\t\t\tdisplay: block\n\t\t&.active\n\t\t\tcolor: $color-blue\n\t\t\t&:before\n\t\t\t\tcontent: ''\n\t\t\tfigure\n\t\t\t\tsvg\n\t\t\t\t\tpath\n\t\t\t\t\t\tfill: $color-blue\n\t\t\t\t\t&.has-stroke\n\t\t\t\t\t\tpath\n\t\t\t\t\t\t\tstroke: $color-blue\n\n\tul\n\t\tmargin: 0\n\t\tdisplay: none\n\t\tfont-size: 14px\n\t\tbackground: #F8F8F8\n\t\tlist-style-type: none\n\t\tpadding: $padding-sidebar\n\t\tli\n\t\t\tmargin-bottom: 15px\n\t\t\t&:last-child\n\t\t\t\tmargin-bottom: 0\n\t\t\ta\n\t\t\t\t&.active\n\t\t\t\t\tfont-weight: 700\n\t\t\t\t\tcolor: $color-blue\n\n.current-network-section\n\tpadding: $padding-sidebar\n\tborder-top: 1px solid $color-border\n\tborder-bottom: 1px solid $color-border\n\n.standard-dropdown-label\n\tcolor: #000\n\tfont-size: 14px\n\tfont-weight: 600\n\t+ .dropdown\n\t\tmargin-top: 3px\n\n.standard-dropdown\n\t.is-active-option\n\t\tbackground: #eee\n\t&.color-purple, &.color-green\n\t\t> .dropdown > button:before\n\t\t\twidth: 12px\n\t\t\theight: 12px\n\t\t\tcontent: \"\"\n\t\t\tmargin-right: 8px\n\t\t\tvertical-align: -1px\n\t\t\tdisplay: inline-block\n\n\t&.color-purple\n\t\t> .dropdown > button:before\n\t\t\tbackground: #8A10BE\n\n\t&.color-green\n\t\t> .dropdown > button:before\n\t\t\tbackground: #51DAAB\n\n\t> .dropdown\n\t\t> .dropdown-menu\n\t\t\tpadding-top: 8px\n\t\t\t.custom-dropdown-search\n\t\t\t\ttop: -8px\n\t\t\t\tmargin-top: -8px\n\t\t\t\tborder-bottom: 1px solid $color-border\n\n\t.is-underlined\n\t\tborder-bottom: 1px solid $color-border\n\n\tinput[type=checkbox]\n\t\tmargin: 0 5px 0 0\n\t\tvertical-align: -2px\n\n/* End side nav */\n\n.page-headline\n\twidth: 100%\n\theight: 68px\n\tcolor: #4f4f4f\n\tfont-size: 22px\n\tmargin: 0 0 18px\n\tbox-sizing: content-box\n\t@include flex-center-start\n\tborder-bottom: 1px solid $color-border\n\n\t&.is-flex\n\t\t@include flex-center-between\n\t\t@include breakpoint\n\t\t\tdisplay: block\n\n\t.search-and-buttons\n\t\t@include flex-center\n\n\tstrong\n\t\tfont-weight: 600\n\n\t@include breakpoint\n\t\theight: auto\n\t\tfont-size: 18px\n\t\ttext-align: center\n\t\tborder-bottom: 0 none\n\n\t\t> div:first-child\n\t\t\twidth: 100%\n\t\t\ttext-align: left\n\t\t\tmargin-bottom: $padding-sidebar\n\t\t\tpadding-bottom: $padding-sidebar\n\t\t\tborder-bottom: 1px solid $color-border\n\n\t\t.interval-selector\n\t\t\tdisplay: inline-block\n\t\t.blue-button\n\t\t\tjustify-content: center\n\t\t.search-and-buttons\n\t\t\tdisplay: block\n\n.info-box\n\tborder-radius: 8px\n\tborder: 1px solid $color-border\n\tbox-shadow: 0px 4px 7px 0px #0000001A\n\n\t&-header\n\t\tfont-size: 16px\n\t\tfont-weight: 600\n\t\tpadding: 12px 20px\n\t\tsvg\n\t\t\tmargin-right: 10px\n\t&-content\n\t\tpadding: 0 20px 15px\n\t\t.chart-box\n\t\t\tpadding: 0\n\t&-footer\n\t\tfont-size: 14px\n\t\tpadding: 12px 20px\n\t\t@include flex-center-between\n\t\tborder-top: 1px solid $color-border\n\n\t\t.icon-chevron-down\n\t\t\tvertical-align: 0\n\t\t\ttransform: rotate(-90deg)\n\n\t\t\tpath\n\t\t\t\tfill: $color-blue\n\n\t+\n\t\t.info-box, .table-box, .debates-box\n\t\t\tmargin-top: 25px\n\n.chart-controls\n\tpadding: 20px\n\tfont-size: 14px\n\t@include flex-center-start\n\n\t> *\n\t\tmargin-right: 10px\n\n.chart-box\n\tpadding: 0 20px 20px\n\n.mid-selector\n\tmargin: 20px 0\n\t.standard-dropdown\n\t\tmax-width: 260px\n\n.table-box\n\tmargin-bottom: 25px\n\tbox-shadow: 0px 4px 7px 0px #0000001A\n\t&-header\n\t\tfont-size: 13px\n\t\tpadding: 12px 15px\n\t\tborder-top-left-radius: 8px\n\t\tborder-top-right-radius: 8px\n\t\t@include flex-center-between\n\t\tborder: 1px solid $color-border\n\t\tborder-bottom: 0 none\n\t\t.text-button\n\t\t\tmargin-right: 15px\n\t&-actions\n\t\t@include flex-center\n\t\t.separator\n\t\t\twidth: 1px\n\t\t\theight: 20px\n\t\t\tmargin: 0 20px\n\t\t\tbackground: $color-border\n\t\t.text-button\n\t\t\tmargin-right: 0\n\t\t\t@include flex-center\n\t\t\tsvg\n\t\t\t\tmargin-right: 7px\n\t\t@include breakpoint\n\t\t\t.separator\n\t\t\t\tdisplay: none\n\t\t\t.text-button\n\t\t\t\tmargin-left: 10px\n\t\t\t\tspan\n\t\t\t\t\tdisplay: none\n\t&-content\n\t\toverflow: auto\n\n\t&-title\n\t\tfont-size: 14px\n\t\t@include flex-center-start\n\t\tsvg\n\t\t\tmargin-right: 7px\n\ttable\n\t\twidth: 100%\n\t\tth, td\n\t\t\tpadding: 8px 15px\n\t\t\tborder: 1px solid $color-border\n\t\tth\n\t\t\tcolor: #000\n\t\t\tcursor: pointer\n\t\t\tfont-size: 13px\n\t\t\tfont-weight: normal\n\t\t\tsvg\n\t\t\t\tmargin-left: 5px\n\t\t\t\tvertical-align: 1px\n\t\ttd\n\t\t\tfont-size: 12px\n\t\t\ttext-align: right\n\t\t\t&:first-child\n\t\t\t\ttext-align: left\n\t\t.totals-row\n\t\t\ttd\n\t\t\t\tcolor: #000\n\t\t\t\tfont-weight: 600\n\t\t\t\tbackground: #E1E0E3\n\t&-pagination\n\t\tpadding: 7px\n\t\tfont-size: 14px\n\t\ttext-align: center\n\t\tborder: 1px solid $color-border\n\t\tborder-top: 0 none\n\n.debates-box\n\tborder-radius: 8px\n\tmargin-bottom: 25px\n\tborder: 1px solid $color-border\n\tbox-shadow: 0px 4px 7px 0px #0000001A\n\n\t&-title\n\t\tpadding: 12px 15px\n\t\th3\n\t\t\tmargin: 0\n\t\t\tfont-size: 16px\n\t\t\tfont-weight: 600\n\t&-content\n\t\tpadding: 20px 50px\n\t\tbackground: linear-gradient(180deg, #E7E7E7 0%, #F8F8F8 100%)\n\t&-list\n\t\toverflow: auto\n\t\twhite-space: nowrap\n\t\t.topDebate\n\t\t\twhite-space: normal\n\n.page-selectors\n\tmargin-bottom: 25px\n\t@include flex-start\n\n\t@include breakpoint\n\t\tdisplay: block\n\n\t.standard-dropdown\n\t\twidth: 260px\n\t\tmargin-right: 12px\n\n\t\t@include breakpoint\n\t\t\tmargin: 0 0 10px\n\t\t\twidth: auto\n\n\t.btn\n\t\tfont-size: 13px\n\n\t\t@include breakpoint\n\t\t\twidth: 100%\n\n.info-stats\n\tflex-wrap: wrap\n\ttext-align: center\n\t@include flex-start-between\n\n\t> div\n\t\twidth: 24%\n\t\tpadding: 10px\n\t\tborder-radius: 4px\n\t\tmargin-bottom: 12px\n\t\tbox-sizing: border-box\n\t\tbackground: $color-background\n\n\t\t@include breakpoint\n\t\t\twidth: 48%\n\n\t.info-stat-title\n\t\tfont-size: 15px\n\t\tfont-weight: 600\n\t\tmargin-bottom: 3px\n\n\t.info-stat-value\n\t\tfont-size: 16px\n\t\t@include flex-center\n\n\t\t.no-change\n\t\t\twidth: 8px\n\t\t\theight: 2px\n\t\t\tmargin: 0 2px 0 7px\n\t\t\tdisplay: inline-block\n\t\t\tbackground: $color-info\n\n\t\tsvg\n\t\t\tmargin: 0 2px 0 7px\n\t\tspan\n\t\t\tfont-size: 13px\n\t\t\tcolor: $color-info\n\n.change-down\n\ttransform: scaleY(-1)\n\tpath\n\t\tfill: #ff0000\n\n.interval-selector\n\tfont-size: 14px\n\tpadding: 0 0 0 10px\n\tborder: 1px solid $color-blue\n\n\t.fa\n\t\t&:before\n\t\t\tcolor: $color-blue\n\tinput\n\t\twidth: 200px\n\t\toutline: none\n\t\tborder: 0 none\n\t\tcursor: pointer\n\t\tcolor: $color-blue\n\t\ttext-align: center\n\t\t&.size-s\n\t\t\twidth: 150px\n\n.mega-form\n\twidth: 100%\n\tmax-width: 640px\n\t&-top\n\t\tmargin-bottom: 5px\n\t\t@include flex-center-end\n\t&-middle\n\t\tmargin-bottom: 10px\n\ttextarea\n\t\tmargin: 0\n\t\twidth: 100%\n\t\theight: 500px\n\t\tpadding: 10px\n\t\tdisplay: block\n\t\tfont-size: 12px\n\t\tborder-radius: 10px\n\t\tbox-shadow: 1px 1px 4px $color-border\n\t\tborder: 1px solid $color-border\n\n\t\t@include breakpoint\n\t\t\theight: 320px\n\t&-bottom\n\t\t@include flex-center-end\n\t\t.blue-button\n\t\t\tmargin-left: 10px\n\n#webpack-dev-server-client-overlay\n\tdisplay: none\n\n.form-box\n\tpadding: 20px\n\tbox-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1)\n\n\t&-title\n\t\tfont-size: 16px\n\t\tfont-weight: 700\n\t\tmargin-bottom: 15px\n\n\t\t&:last-child\n\t\t\tmargin-bottom: 0\n\n\t&-description\n\t\tfont-size: 12px\n\t\tfont-weight: 700\n\t\tline-height: 1.5\n\t\tmargin-bottom: 15px\n\n\t&-image\n\t\ttext-align: center\n\t\tmargin-bottom: 15px\n\t\timg\n\t\t\tmax-width: 100%\n\t\t\tmax-height: 120px\n\n\t&-field\n\t\tmargin-bottom: 10px\n\n\t\tinput\n\t\t\twidth: 100%\n\t\t\theight: 40px\n\t\t\tpadding: 0 10px\n\t\t\tfont-size: 12px\n\t\t\tbackground: #fff\n\t\t\tborder-radius: 5px\n\t\t\tbox-sizing: border-box\n\t\t\tborder: 1px solid #DBDBDB\n\n\t&-submit\n\t\twidth: 100%\n\t\theight: 40px\n\t\tdisplay: block\n\t\tpadding: 0 10px\n\t\tfont-weight: 700\n\t\tborder-radius: 5px\n\t\tmargin: 20px 0 15px\n\t\tfont-size: 12px !important\n\n\t&-terms\n\t\tfont-size: 10px\n\t\tline-height: 1.4\n\t\tcolor: #9b9b9b\n\t\ttext-align: center\n\n\t\ta\n\t\t\tfont-size: 10px\n\t\t\tdisplay: contents\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
